export const integrationsPtBr = {
  itauBoleto: {
    discardTitle: 'Descartar alterações?',
    discard: 'Descartar',
    keepEditing: 'Continuar editando',
    certificateInvalid:
      'Certificado, chave privada ou senha inválidos. Confira os arquivos e a senha.',
    certificateRequired:
      'Informe o certificado e a chave privada juntos. Ambos são obrigatórios em produção.',
    credentialsInvalid: 'Informe um Client ID e um Client secret válidos.',
    tooLong: 'Use até {{count}} caracteres.',
    discardHint: 'As alterações nas credenciais ainda não foram salvas e serão descartadas.',
    accountPermission:
      'Solicite acesso de leitura às contas bancárias para registrar notificações.',
    entity: 'Entidade',
    selectEntity: 'Selecione a entidade',
    selectEntityHint: 'Escolha a entidade que emitirá boletos.',
    noPermission: 'Sem acesso à configuração',
    noPermissionHint: 'Solicite a permissão para gerenciar integrações.',
    noEntities: 'Nenhuma entidade disponível',
    noEntitiesHint: 'Cadastre uma entidade para configurar a emissão de boletos.',
    credentials: 'Credenciais Itaú boleto',
    replaceHint:
      'Ao salvar, todas as credenciais desta entidade são substituídas. Informe novamente o segredo e, se usados, o certificado e a chave privada.',
    requiredLegend: 'obrigatório',
    required: 'Preencha este campo.',
    proposedClientIdRequired: 'Informe o client ID',
    proposedClientSecretRequired: 'Informe o client secret',
    proposedCertificateRequired:
      'Informe o certificado quando o ambiente for produção ou houver dados do certificado',
    proposedPrivateKeyRequired:
      'Informe a chave privada quando o ambiente for produção ou houver dados do certificado',
    environment: 'Ambiente',
    sandbox: 'Sandbox',
    production: 'Produção',
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    certificate: 'Certificado digital',
    certificateHint:
      'Produção exige certificado e chave privada correspondentes. Os dados salvos não são exibidos.',
    certificatePem: 'Certificado PEM',
    privateKeyPem: 'Chave privada PEM',
    passphrase: 'Senha da chave privada',
    webhook: 'Notificações de pagamento',
    webhookHint: 'Escolha a conta Itaú beneficiária para registrar as notificações de pagamento.',
    webhookRegistered:
      'Notificações registradas. Você pode registrar novamente para a conta selecionada.',
    bankAccount: 'Conta beneficiária',
    selectBankAccount: 'Selecione a conta Itaú',
    itauAccountOnly: 'Selecione uma conta Itaú desta entidade.',
    registerWebhook: 'Registrar notificações',
    registering: 'Registrando…',
    saveFirst: 'Salve as credenciais antes de registrar as notificações.',
    save: 'Salvar',
    saving: 'Salvando…',
    cancel: 'Cancelar',
    saved: 'Configuração Itaú boleto salva',
    saveError: 'Não foi possível salvar. Confira as credenciais e o certificado e tente novamente.',
    webhookSaved: 'Notificações registradas',
    webhookError:
      'Não foi possível registrar as notificações. Confira a conta e a configuração pública da integração e tente novamente.',
  },
  avenia: {
    cardTitle: 'Conexão Avenia',
    cardDescription:
      'Conecte a conta principal Avenia para importar o extrato de cada token na conta bancária escolhida.',
    loading: 'Carregando conexão Avenia',
    loadError: 'Não foi possível carregar a conexão Avenia. Tente novamente.',
    emptyReadOnly: 'Nenhuma conta Avenia conectada. Peça a um administrador para conectar.',
    step1Title: '1. Gere a chave de assinatura',
    step1Hint:
      'O Alchemy gera um par de chaves e guarda a chave privada. Copie a chave pública e cadastre-a na Avenia ao criar a API key da conta principal.',
    generateKey: 'Gerar chave',
    publicKey: 'Chave pública',
    copyKey: 'Copiar chave pública',
    keyCopied: 'Chave pública copiada',
    newKey: 'Gerar nova chave',
    step2Title: '2. Informe o Key ID da Avenia',
    step2Hint:
      'Depois de cadastrar a chave pública, a Avenia mostra o Key ID. Cole-o aqui. A conexão é verificada antes de salvar.',
    keyId: 'Key ID',
    historyLabel: 'Importar histórico de',
    historyKept: 'Desde {{date}}, o mesmo período da primeira conexão',
    historyMonths_one: 'Último mês',
    historyMonths_other: 'Últimos {{count}} meses',
    connect: 'Verificar e conectar',
    connecting: 'Verificando conexão…',
    connected: 'Conta Avenia conectada',
    keyHint: 'Key ID ••••{{hint}}',
    lastSynced: 'Última sincronização: {{date}}',
    neverSynced: 'Ainda não sincronizada',
    historySince: 'Histórico desde {{date}}',
    syncNow: 'Sincronizar agora',
    syncQueued: 'Sincronização iniciada',
    disconnect: 'Desconectar',
    disconnectTitle: 'Desconectar Avenia?',
    disconnectHint:
      'A chave de assinatura é apagada e a importação para. As movimentações já importadas e os vínculos dos tokens continuam.',
    disconnected: 'Avenia desconectada',
    disconnectError: 'Não foi possível desconectar. Tente novamente.',
    positions: 'Tokens da conta',
    positionsHint:
      'Escolha a empresa e a conta bancária de cada token. A conta precisa estar na mesma moeda do token (USDC em USD, BRLA em BRL).',
    noPositions: 'Nenhum token ainda',
    noPositionsHint: 'Os tokens aparecem depois da primeira sincronização, em alguns instantes.',
    token: 'Token',
    entity: 'Empresa',
    entityLabel: 'Empresa do token {{token}}',
    bankAccount: 'Conta bancária',
    bankAccountLabel: 'Conta bancária do token {{token}}',
    bankAccountPlaceholder: 'Selecione a conta',
    pickEntityFirst: 'Escolha a empresa primeiro',
    status: 'Situação',
    importing: 'Importando',
    unmapped: 'Sem conta vinculada',
    mapped: 'Vinculada',
    reconnect: 'Reconectar com nova chave',
    saveMapping: 'Salvar',
    saveMappingLabel: 'Salvar vínculo do token {{token}}',
    mappingSaved: 'Vínculo salvo. A importação começa em instantes.',
    createBankAccount: 'Criar conta Avenia {{token}}',
    bankAccountCreated:
      'Conta Avenia {{token}} criada e vinculada. A importação começa em instantes.',
    connectionStatus: {
      ACTIVE: 'Conectada',
      INACTIVE: 'Inativa',
      ERROR: 'Conexão com falha',
    },
    block: {
      generic: 'Importação bloqueada',
      BALANCE_CHAIN_BROKEN: 'Bloqueado: saldo do extrato não fecha',
      SOURCE_CHANGED: 'Bloqueado: movimentação alterada na Avenia',
      AMBIGUOUS_ORDER: 'Bloqueado: ordem das movimentações incerta',
      MAPPING_REQUIRED: 'Aguardando conta vinculada',
      AVENIA_TOKEN_UNSUPPORTED: 'Token ainda não suportado',
      DIRECTION_UNVERIFIED: 'Bloqueado: entrada ou saída não confirmada',
      SOURCE_POLICY_BLOCKED: 'Bloqueado pela política de importação da conta',
      WRITER_REJECTED: 'Bloqueado: movimentação recusada na importação',
      MAPPING_INVALID:
        'Bloqueado: a conta bancária vinculada não está mais disponível; vincule outra',
      INVALID_TIMESTAMP: 'Bloqueado: data da movimentação inválida',
      INVALID_NATIVE_AMOUNT: 'Bloqueado: valor da movimentação inválido',
    },
    blockEvidence: 'Movimentação Avenia {{logId}}',
    missingOpRead:
      'Para vincular contas bancárias, você precisa também das permissões op:read e org:read.',
    errors: {
      generic: 'Não foi possível concluir. Tente novamente em alguns minutos.',
      KEY_DRAFT_NOT_FOUND: 'A chave gerada não foi encontrada. Gere uma nova chave.',
      KEY_DRAFT_CHANGED: 'Uma chave mais nova foi gerada. Use a chave pública que aparece agora.',
      AVENIA_VALIDATION_FAILED:
        'A Avenia não aceitou a conexão. Confira se a chave pública cadastrada é esta e se o Key ID está correto.',
      ACCOUNT_IDENTITY_CHANGED:
        'Este Key ID é de outra conta Avenia. Desconecte antes de conectar uma conta diferente.',
      CONNECTION_CHANGED: 'A conexão mudou enquanto você editava. Recarregue a página.',
      AVENIA_TOKEN_UNSUPPORTED: 'Este token ainda não é suportado.',
      CURRENCY_MISMATCH: 'A conta bancária precisa estar na mesma moeda do token.',
      MISSING_ACCOUNT_CURRENCY_EVIDENCE:
        'Confirme a moeda da conta bancária no cadastro da conta antes de vinculá-la.',
      MAPPING_HAS_IMPORTS:
        'Este token já tem movimentações importadas nesta conta e não pode mudar de conta.',
      BANK_ALREADY_MAPPED: 'Esta conta bancária já está vinculada a outro token.',
      AVENIA_TOKEN_BLOCKED:
        'A importação de um token foi bloqueada para revisão. Veja a situação na lista de tokens.',
      AUTH_FAILED:
        'A Avenia recusou a chave. Reconecte com uma nova chave e confira o cadastro na Avenia.',
      SYNC_FAILED: 'A última sincronização falhou. Ela é tentada de novo automaticamente.',
      PAGINATION_INCOMPLETE:
        'A Avenia não devolveu o extrato completo. A sincronização é tentada de novo automaticamente.',
    },
  },
  brex: {
    cardTitle: 'Conexão Brex',
    cardDescription: 'Uma chave por conta Brex; mapeie as legal entities para as empresas Alchemy.',
    connectAccount: 'Conectar conta Brex',
    connectTitle: 'Conectar conta Brex',
    empty: 'Nenhuma conta Brex conectada. Conecte a chave da conta Brex.',
    emptyReadOnly: 'Nenhuma conta Brex conectada. Peça a um administrador para conectar.',
    title: 'Brex',
    alchemyEntity: 'Empresa Alchemy',
    token: 'Chave de acesso',
    tokenHint:
      'Cole a chave da conta Brex com permissão legal_entities.readonly. Ela será verificada antes de salvar.',
    tokenRequired: 'Informe a chave de acesso da Brex.',
    tokenTooLong: 'A chave deve ter até 500 caracteres. Confira a chave no painel da Brex.',
    connect: 'Testar e conectar',
    saving: 'Verificando conexão…',
    saved: 'Conexão Brex salva',
    loading: 'Carregando conexão Brex',
    loadError: 'Não foi possível carregar as conexões. Tente novamente.',
    authError: 'A Brex não aceitou a chave. Confira a chave e as permissões no painel da Brex.',
    invalidToken: 'A chave não pôde ser usada. Copie novamente a chave no painel da Brex.',
    unavailable: 'Não foi possível acessar a Brex. Tente novamente em alguns minutos.',
    saveError: 'Não foi possível salvar a conexão. Tente novamente em alguns minutos.',
    noCompanies: 'Nenhuma empresa disponível',
    noCompaniesHint: 'Cadastre uma empresa no Alchemy para associá-la a uma empresa Brex.',
    lastValidated: 'Última verificação: {{date}}',
    readOnly:
      'Para alterar a conexão, fale com um administrador com permissão para gerenciar integrações.',
    missingScope:
      'A chave precisa da permissão legal_entities.readonly. Ajuste as permissões no painel da Brex.',
    alreadyMapped:
      'Esta empresa Alchemy já está associada a outra empresa Brex. Remova a associação anterior primeiro.',
    notFound: 'A empresa não está mais disponível. Recarregue a página e confira o mapeamento.',
    mappings: 'Mapeamento de empresas',
    mappingHint:
      'Associe cada empresa Brex à empresa correspondente no Alchemy. Cada associação é salva separadamente. Contas, cartões e transações só entram no Alchemy depois que a empresa é associada.',
    brexEntity: 'Empresa Brex',
    mappingLabel: 'Empresa Alchemy para {{name}}',
    unmapped: 'Não mapear',
    refresh: 'Atualizar empresas Brex',
    refreshed: 'Empresas Brex atualizadas',
    mappingSaved: 'Mapeamento salvo',
    saveMapping: 'Salvar',
    saveMappingLabel: 'Salvar mapeamento de {{name}}',
    noLegalEntities: 'Nenhuma empresa Brex encontrada',
    noLegalEntitiesHint: 'Confira as empresas da conta no painel da Brex e atualize a lista.',
    entitiesError: 'Não foi possível carregar as empresas Alchemy. Tente novamente.',
    discardTitle: 'Descartar alterações?',
    discardHint: 'A chave e os mapeamentos ainda não salvos serão descartados.',
    discard: 'Descartar e sair',
    keepEditing: 'Continuar editando',
    syncInitial:
      'Sincronização inicial desde {{date}} em andamento — pode levar alguns minutos. Você pode sair desta tela.',
    syncInitialDefault:
      'Sincronização inicial dos últimos 12 meses em andamento — pode levar alguns minutos. Você pode sair desta tela.',
    historyLabel: 'Importar histórico desde',
    historyMonths_one: '{{count}} mês atrás',
    historyMonths_other: '{{count}} meses atrás',
    historyHint: 'Vale só para a primeira sincronização; depois busca só novidades.',
    historySince: 'Histórico desde {{date}}',
    syncQueued: 'Na fila: aguardando a sincronização em andamento terminar.',
    syncQueuedShort: 'Na fila: aguardando a vez para sincronizar.',
    syncFetching: 'Buscando novidades…',
    syncNow: 'Sincronizar agora',
    syncing: 'Sincronizando…',
    syncDone: 'Sincronização da Brex concluída',
    syncFailed: 'A sincronização da Brex falhou. Tente novamente em alguns minutos.',
    syncAlreadyRunning: 'Já existe uma sincronização em andamento.',
    lastSynced: 'Última sincronização: {{date}}',
    neverSynced: 'Ainda não sincronizado',
    keyHint: 'Chave ••••{{hint}}',
    payments: {
      label: 'Pagamentos',
      enabled: 'Liberado',
      missingScope:
        'O token não tem permissão de pagamentos — gere um token com os escopos de transferências e fornecedores e cole aqui',
      unknown: 'Não foi possível verificar',
    },
    replaceKey: 'Substituir chave',
    replaceTitle: 'Substituir chave da Brex',
    replaceHint:
      'Cole a nova chave. Ela será verificada antes de substituir a atual; se a verificação falhar, a conexão atual é mantida.',
    replaceConfirm: 'Testar e substituir',
    replaced: 'Chave substituída',
    disconnect: 'Desconectar',
    disconnectTitle: 'Desconectar a Brex?',
    disconnectHint:
      'A chave será apagada e o Alchemy deixará de acessar a Brex. Os mapeamentos de empresas são mantidos e voltam a valer ao reconectar.',
    disconnected: 'Brex desconectada',
    disconnectError: 'Não foi possível desconectar. Tente novamente.',
    status: {
      ACTIVE: 'Conectada',
      INACTIVE: 'Inativa',
      ERROR: 'Conexão com falha',
      UNCONFIGURED: 'Não conectada',
    },
  },
  common: {
    empty: '—',
    actions: {
      cancel: 'Cancelar',
    },
  },
  setupCard: {
    title: 'Configurar {{name}}',
    description: {
      focusNfe: 'Ative a integração para habilitar a configuração por entidade (certificado A1).',
      tecnospeed:
        'Ative a integração para permitir envio de pagamentos AP via VAN Tecnospeed. As credenciais da Software House ficam no servidor da API; aqui você habilita o tenant e escolhe o ambiente de referência.',
      openFinance:
        'Conecte contas bancárias e cartões via Open Finance Brasil. Não há credenciais para configurar.',
      default: 'Complete as credenciais abaixo para ativar a integração',
    },
    requiredFields: 'Campos obrigatórios',
    footerHint: 'Você poderá ajustar estas configurações depois',
    connecting: 'Conectando...',
    connect: 'Conectar {{name}}',
    toasts: {
      configError: 'Falha ao configurar a integração. Verifique suas credenciais.',
    },
    kamino: {
      formAria: 'Credenciais Kamino',
      pasteShow: 'Colar credenciais (formato texto)',
      pasteHide: 'Ocultar área de colagem',
      pastePlaceholder:
        'Cole as credenciais aqui no formato:\nApp: xxx\nCN: xxx\nIDUsr: xxx\nUsr: xxx\nHash: xxx',
      pasteHelper: 'Cole o bloco de credenciais e os campos serão preenchidos automaticamente.',
      fields: {
        app: {
          label: 'App (Application Token)',
          placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
          helper: 'Application token fornecido pela Kamino',
        },
        companyGuid: {
          label: 'C (Company GUID) - Opcional',
          placeholder: 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX',
          helper: 'GUID da empresa (necessário para API genérica api.kamino.tech)',
        },
        companyIdentifier: {
          label: 'CN (Company Identifier)',
          placeholder: 'NomeDaEmpresa123',
          helper: 'Identificador da empresa no Kamino',
        },
        userId: {
          label: 'IDUsr (User ID)',
          placeholder: '123',
          helper: 'ID do usuário no Kamino',
        },
        userToken: {
          label: 'Usr (User Token)',
          placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
          helper: 'Token do usuário no Kamino',
        },
        hash: {
          label: 'Hash (Validation Hash)',
          placeholder: 'Base64 encoded hash...',
          helper: 'Hash de validação fornecido pela Kamino',
        },
      },
    },
    openFinance: {
      connectAccounts: 'Conectar contas',
    },
    focusNfe: {
      formAria: 'Ativação Focus NFe',
      masterTokenNote:
        'O token master do Focus NFe é gerenciado pelo sistema (nenhuma conta Focus é necessária).',
      footerHint: 'Você poderá configurar cada entidade após ativar',
      activating: 'Ativando...',
      activate: 'Ativar {{name}}',
    },
    tecnospeed: {
      formAria: 'Ativação Tecnospeed Pagamentos',
      platformNote:
        'Não cole chaves aqui: a comunicação com a Tecnospeed (Pagamento Bancário / SH) usa credenciais globais da plataforma Alchemy.',
      bullet1:
        'Ativar esta integração é o “opt-in” comercial: confirma que o tenant pode usar o fluxo Tecnospeed habilitado pela Alchemy.',
      bullet2:
        'Por conta bancária, registre o convênio VAN e a autorização exigida pelo banco (carta / fluxo do banco).',
      bullet3:
        'Use a documentação do Pagamento Bancário para prazos e formatos de carta por instituição.',
      bullet4:
        'Ao ativar, o ERP tenta registrar automaticamente o cedente (pagador) na Tecnospeed para cada entidade com CNPJ de 14 dígitos.',
      environmentLabel: 'Ambiente registrado no tenant',
      staging: 'Homologação (staging)',
      production: 'Produção',
      helper:
        'Credenciais da Software House (CNPJ + token) ficam nas variáveis de ambiente da API (`TECNOSPEED_CNPJ_SH`, `TECNOSPEED_TOKEN_SH`). O ambiente da API em runtime segue `TECNOSPEED_ENVIRONMENT` no servidor; o valor abaixo é salvo na configuração do tenant para referência.',
      footerHint: 'Depois de ativar, abra Contas bancárias para concluir o cadastro por banco.',
      activating: 'Ativando...',
      activate: 'Ativar {{name}}',
    },
    itau: {
      environmentLabel: 'Ambiente Itaú',
      environmentHelper:
        'Use homologação (sandbox) até validar fluxos; só altere para produção com credenciais e contrato de produção. Com os hosts padrão do ERP, sandbox e produção usam o mesmo api.itau.com.br — o Itaú costuma separar o ambiente por credenciais/contrato, não por hostname.',
      validation: {
        invalidCertificatePem:
          'Certificado PEM inválido. Cole o bloco completo com BEGIN/END CERTIFICATE.',
        invalidPrivateKeyPem:
          'Chave privada PEM inválida. Cole o bloco completo com BEGIN PRIVATE KEY (ou equivalente).',
      },
      pemDrop: {
        certificateHint: 'Arraste um arquivo .crt / .pem ou escolha um arquivo.',
        privateKeyHint: 'Arraste um arquivo .key / .pem ou escolha um arquivo.',
        chooseFile: 'Escolher arquivo',
        chooseCertificateFile: 'Escolher arquivo de certificado',
        choosePrivateKeyFile: 'Escolher arquivo de chave privada',
        readFailed:
          'Não foi possível ler um ou mais arquivos. Tente outro arquivo ou cole o texto PEM.',
        noMatchingFileCertificate:
          'Nenhum certificado PEM encontrado. Use um .crt/.pem com BEGIN CERTIFICATE.',
        noMatchingFilePrivateKey:
          'Nenhuma chave privada PEM encontrada. Use um .key/.pem com BEGIN PRIVATE KEY.',
      },
    },
    generic: {
      placeholders: {
        select: 'Selecione...',
        apiKey: 'sk_live_...',
        secret: '••••••••',
      },
      environment: {
        production: 'Produção',
        sandbox: 'Sandbox',
      },
      entities: {
        main: 'Empresa Principal',
        branchSp: 'Filial São Paulo',
        branchRio: 'Filial Rio de Janeiro',
      },
    },
    optionalFields: 'Configurações opcionais',
    optionalFieldsPlaceholder: 'Deixe em branco para configurar depois',
    help: {
      title: 'Precisa de ajuda?',
      descriptionPrefix: 'Consulte a',
      documentation: 'documentação do {{name}}',
      descriptionSuffix: 'para obter suas credenciais.',
    },
  },
  pluggyConnect: {
    title: 'Conectar contas Open Finance',
    description:
      'Selecione a entidade e conecte suas contas bancárias e cartões de crédito através do Open Finance Brasil.',
    entityLabel: 'Entidade',
    entityPlaceholder: 'Selecione a entidade',
    entityHelper: 'A conexão será vinculada a esta entidade para conciliação.',
    selectEntity: 'Selecione uma entidade',
    tokenError: 'Falha ao obter token. Verifique se o Open Finance está configurado.',
    success: 'Contas conectadas com sucesso!',
    successConservative: 'Autorização concluída. As contas serão vinculadas em instantes.',
    error: 'Erro ao conectar. Tente novamente.',
    closedWithoutSuccess:
      'Conexão não finalizada. A autorização foi cancelada ou não se completou. Você pode tentar novamente.',
    closedWithoutSuccessNamed:
      'Conexão com {{institution}} não finalizada. Tente novamente ou escolha outra instituição.',
    loading: 'Gerando link...',
    continue: 'Continuar',
  },
  plaidConnect: {
    title: 'Conectar banco dos EUA',
    description:
      'Escolha a entidade dona das contas e entre no banco pela janela do Plaid. Só leitura: saldos, transações e investimentos.',
    entityLabel: 'Entidade',
    entityPlaceholder: 'Selecione a entidade',
    connect: 'Conectar banco',
    connecting: 'Conectando…',
    tokenError: 'Não foi possível iniciar a conexão com o Plaid. Tente novamente.',
    success: 'Instituição conectada',
    syncPending:
      'Instituição conectada. O Plaid ainda está preparando os dados; a sincronização continuará em seguida.',
    exchangeError: 'Não foi possível concluir a conexão da instituição.',
    refreshError: 'O banco foi conectado, mas a página não foi atualizada. Recarregue a página.',
    historyLabel: 'Importar histórico desde',
    historyMonths_one: '{{count}} mês atrás',
    historyMonths_other: '{{count}} meses atrás',
    historyHint: 'Vale só para a primeira sincronização; depois busca só novidades.',
    alreadyConnected:
      'Esta instituição já está conectada nesta entidade. Use Reconectar na conexão existente; se for outra conta do mesmo banco, fale com o suporte.',
    existingConnections:
      'Esta entidade já tem: {{institutions}}. Para um banco já conectado, use Reconectar na lista de conexões.',
  },
  plaidConnections: {
    title: 'Contas conectadas via Plaid',
    description:
      'Cada instituição fica vinculada a uma entidade. As contas importadas ficam disponíveis no fluxo de caixa e na conciliação.',
    loadError: 'Não foi possível carregar as conexões Plaid.',
    missingOpRead: 'Você precisa da permissão op:read para ver as contas conectadas via Plaid.',
    retry: 'Tentar novamente',
    connectAnother: 'Conectar outra instituição',
    connectFirst: 'Conectar instituição',
    empty: 'Nenhuma conexão Plaid ativa.',
    unknownInstitution: 'Instituição Plaid',
    unknownEntity: 'Entidade não encontrada',
    missingEntity: 'Entidade não definida',
    entity: 'Entidade: {{entity}}',
    lastSync: 'Última sincronização: {{date}}',
    neverSynced: 'Ainda não sincronizada',
    transactionsSynced: 'Transações sincronizadas',
    awaitingFirstSync: 'Aguardando transações',
    noAccountsYet: 'As contas ainda estão sendo disponibilizadas pela instituição.',
    syncNow: 'Sincronizar agora',
    syncing: 'Sincronizando...',
    syncPending: 'A instituição ainda está processando a conexão. Tente novamente em instantes.',
    syncProviderError: 'O Plaid retornou o erro {{code}}. Pode ser necessário reconectar.',
    syncSuccess:
      'Sincronização concluída: {{bank}} transações bancárias, {{card}} de cartão e {{investments}} investimentos importados.',
    syncError: 'Não foi possível sincronizar esta conexão Plaid.',
    disconnect: 'Desconectar',
    disconnectTitle: 'Desconectar instituição?',
    disconnectDescription:
      'O acesso do Plaid a {{institution}} será revogado e novas sincronizações serão interrompidas. As contas, transações e conciliações já importadas permanecerão no ERP.',
    confirmDisconnect: 'Desconectar instituição',
    disconnecting: 'Desconectando...',
    disconnectSuccess: 'Instituição desconectada do Plaid.',
    disconnectError: 'Não foi possível desconectar esta instituição.',
    reconnect: 'Reconectar',
    reconnectNeeded:
      'A instituição pediu um novo login. Reconecte para retomar a sincronização sem criar uma nova conexão.',
    reconnectError: 'Não foi possível iniciar a reconexão com o Plaid.',
    importedFrom:
      'Este banco já tinha lançamentos no sistema; importamos a partir de {{date}} para não duplicar.',
    awaitingLink:
      'Contas aguardando vínculo manual: {{count}}. A fonte que as alimentava saiu; fale com o suporte para vinculá-las sem duplicar o histórico.',
    heldPreLink:
      'Lançamentos anteriores à conexão retidos para revisão: {{count}}. Podem já estar no sistema; fale com o suporte para revisá-los.',
    cancel: 'Cancelar',
    status: {
      ACTIVE: 'Ativa',
      PENDING_AUTH: 'Processando',
      ERROR: 'Requer atenção',
      SUSPENDED: 'Suspensa',
      INACTIVE: 'Inativa',
    },
  },
  pluggyStatusBanner: {
    title_one: 'Instabilidade em conector bancário (Pluggy)',
    title_other: 'Instabilidade em {{count}} conectores bancários (Pluggy)',
    description:
      'A integração Open Finance (Pluggy) reporta conectores indisponíveis ou instáveis. Sincronizações e conciliação podem ser afetadas até a normalização.',
    connectors: 'Conectores afetados: {{labels}}.',
    statusPageLink: 'Ver status da Pluggy',
    dismiss: 'Dispensar aviso',
  },
  connectedAccounts: {
    title: 'Contas conectadas',
    description: 'Contas bancárias e cartões vinculados via Open Finance Brasil.',
    empty:
      'Nenhuma conta conectada. Clique em "Conectar contas" para vincular contas bancárias e cartões via Open Finance Brasil.',
    emptyShort: 'Nenhuma conta conectada.',
    institution: 'Instituição',
    status: 'Status',
    lastSync: 'Última sincronização',
    unlink: 'Desvincular',
    cancelPending: 'Cancelar',
    deletePending: 'Excluir',
    cancelPendingSuccess: 'Conexão pendente removida.',
    cancelPendingError: 'Erro ao remover conexão. Tente novamente.',
    pendingConnectionLabel: 'Conexão pendente',
    pendingConnectionDescription:
      'A autorização não foi concluída. Tente novamente ou cancele esta conexão.',
    unlinkComingSoon: 'Desvincular — Em breve',
    unlinkComingSoonTooltip:
      'A desvinculação completa (LGPD, revogação no provedor) estará disponível em breve.',
    unlinkSuccess: 'Conta desvinculada com sucesso.',
    unlinkError: 'Erro ao desvincular conta. Tente novamente.',
    connectButton: 'Conectar contas',
    glPending: 'GL pendente',
    glPendingPerAccountTooltip: 'Conta contábil não vinculada. Clique para editar e vincular.',
    glPendingAlert:
      'Algumas contas estão sem conta contábil vinculada. Configure agora antes de conciliar transações.',
    ownerDocumentMismatchTitle: 'Titularidade da conta divergente',
    ownerDocumentMismatchDescription:
      'A titularidade informada pelo banco em {{count}} conta(s) não corresponde ao CNPJ da entidade selecionada. Revise a conexão antes de usar estes dados.',
    ownerDocumentMismatchBlockedDescription:
      'A conexão foi suspensa porque a titularidade informada pelo banco em {{count}} conta(s) não corresponde ao CNPJ da entidade selecionada.',
    glConfig: {
      open: 'Configurar contas contábeis',
      title: 'Configurar contas contábeis',
      description:
        'Confirme uma conta contábil existente ou crie uma nova para cada conta Open Finance pendente.',
      empty: 'Todas as contas conectadas já têm conta contábil vinculada.',
      bankLabel: 'Conta bancária',
      cardLabel: 'Cartão',
      cardInstitutionGroupLabel: 'Cartões do mesmo emissor',
      cardGroupLabel: '{{institutionName}} ({{cardCount}} cartões)',
      suggestion: 'Sugestão pré-selecionada',
      selectPlaceholder: 'Selecione a conta contábil',
      create: 'Criar nova',
      link: 'Vincular',
      linkSuccess: 'Conta contábil vinculada com sucesso.',
      linkError: 'Não foi possível vincular a conta contábil.',
      createSuccess: 'Conta contábil criada e vinculada com sucesso.',
      createError: 'Não foi possível criar a conta contábil.',
      loadError:
        'Não foi possível carregar os dados necessários para configurar as contas contábeis.',
      retry: 'Tentar novamente',
      confirmBulkTitle: 'Aplicar a todos os cartões deste emissor?',
      confirmBulkDescription:
        'A instituição {{institutionName}} tem {{cardCount}} cartão(ões) pendente(s). A conta contábil {{glAccountName}} será vinculada a todos eles.',
      confirmBulkConfirm: 'Vincular a {{cardCount}} cartão(ões)',
      confirmBulkCancel: 'Cancelar',
    },
    entityLabel: 'Entidade',
    resumeAuth: 'Continuar autorização',
    resumeAuthDescription:
      'Complete a autorização no aplicativo do banco para ativar esta conexão.',
    reconnect: 'Reconectar',
    reconnectDescription: 'Reabra o widget para adicionar contas ou atualizar o consentimento.',
    tryResync: 'Tentar re-sincronizar',
    tryResyncDescription:
      'Tenta re-sincronizar usando as credenciais armazenadas. Se não funcionar, use Reconectar.',
    tryResyncSuccess: 'Re-sincronização iniciada. Aguarde alguns segundos.',
    tryResyncRequiresReconnect:
      'Credenciais inválidas ou expiradas. Use Reconectar para autorizar novamente.',
    syncTransactions: 'Sincronizar',
    syncTransactionsTitle: 'Buscar transações das contas bancárias e cartões desta conexão',
    syncInvestments: 'Sincronizar investimentos',
    syncInvestmentsTitle: 'Buscar posições de investimento (CDB, fundos, ações) desta conexão',
    syncInvestmentsSuccess:
      'Investimentos sincronizados: {{positionsProcessed}} posição(ões), {{transactionsCreated}} transação(ões).',
    syncInvestmentsError: 'Erro ao sincronizar investimentos. Tente novamente.',
    syncLoans: 'Sincronizar empréstimos',
    syncLoansTitle: 'Buscar contratos de crédito desta conexão',
    syncLoansSuccess: 'Empréstimos sincronizados: {{positionsProcessed}} contrato(s).',
    syncLoansError: 'Erro ao sincronizar empréstimos. Tente novamente.',
    syncSuccess:
      'Sincronização enfileirada. {{accountsSynced}} conta(s), {{totalRecords}} transação(ões).',
    syncError: 'Erro ao sincronizar transações. Tente novamente.',
    reprocess: 'Reprocessar',
    reprocessTitle: 'Reexecutar a sincronização de contas bancárias/cartões desta conexão',
    reprocessSuccess: 'Reprocessamento enfileirado. Job: {{jobId}}',
    reprocessError: 'Erro ao reprocessar conexão. Tente novamente.',
    backfillAccountData: 'Atualizar dados da conta',
    backfillAccountDataTitle: 'Corrigir dados da conta a partir de metadata',
    backfillDialogTitle: 'Como deseja atualizar?',
    backfillDialogDescription: 'Escolha o tipo de atualização:',
    backfillOptionAccountDataOnly: 'Somente dados de identificação (agência, conta, banco)',
    backfillOptionAccountDataOnlyDesc:
      'Atualiza apenas os dados da conta a partir de metadata. Não sincroniza transações.',
    backfillOptionFull: 'Reprocessamento completo (inclui transações)',
    backfillOptionFullDesc: 'Reexecuta a sincronização de contas e busca transações.',
    backfillSuccessAccountData: '{{count}} conta(s) atualizada(s).',
    backfillSuccessFull: 'Reprocessamento completo enfileirado.',
    backfillError: 'Erro ao atualizar. Tente novamente.',
    reprocessDialogTitle: 'Confirmar reprocessamento',
    reprocessDialogDescription:
      'Será reexecutada a sincronização das contas bancárias e cartões desta conexão. Isso pode recriar contas que faltaram ou atualizar dados existentes. Deseja continuar?',
    unlinkDialogTitle: 'Confirmar desvinculação',
    unlinkDialogDescription:
      'A conexão será desativada e não aparecerá mais na listagem. As contas bancárias e cartões vinculados permanecerão no sistema, mas não receberão mais sincronização automática. Deseja continuar?',
    reactivate: 'Reativar',
    statusLabels: {
      PENDING_AUTH: 'Aguardando autorização',
      ACTIVE: 'Ativo',
      INACTIVE: 'Inativo',
      ERROR: 'Erro',
      SUSPENDED: 'Suspenso',
    },
    connectedAt: 'Conectado em {{date}}',
    dueDay: 'Venc. dia {{day}}',
    openFinanceSyncInfoTitle: 'Dados do Open Finance — como tudo se atualiza',
    openFinanceSyncInfoIconTooltip:
      'Toca para ver, em palavras simples, de onde vêm os movimentos e o saldo. Se houver diferença entre saldo e extrato, explicamos o que fazer.',
    openFinanceSyncInfoBullet1:
      'Novas movimentações ou alterações na conexão são notificadas ao ambiente, em regra quase em tempo real.',
    openFinanceSyncInfoBullet2:
      'Sincronizações automáticas periódicas reforçam dados atrasados ou pendentes.',
    openFinanceSyncInfoBullet3:
      'Para atualizar manualmente, use «Sincronizar» na conexão (Integrações).',
    openFinanceSyncInfoBullet3BankStatement:
      'Para atualizar manualmente, use «Sincronizar pendências» na aba Extrato (sincroniza transações e recalcula o saldo diário do período).',
    openFinanceSyncInfoBullet4:
      'Saldo de conta e lista de transações podem atualizar em momentos distintos; o extrato costuma convergir em seguida.',
    openFinanceSyncInfoFootCardStatement:
      'Ao voltar para esta aba, a lista de faturas e movimentos é atualizada.',
  },
  featuresPreview: {
    title: 'O que você terá',
    emptyFeatures: 'Nenhuma funcionalidade listada',
    syncedDataTitle: 'Dados sincronizados',
    moreModules: '+ {{count}} módulos adicionais',
    emptyModules: 'Nenhum módulo de dados disponível',
    focusNfeExtraFeatures: {
      issueNfe: 'Emissão de NFe',
      issueNfse: 'Emissão de NFS-e',
      nfeManifestation: 'Manifestação de NF-e',
    },
  },
  pipefyConfiguration: {
    title: 'Configuração do Pipefy',
    description:
      'Configure uma conexão e um pipe para todas as entidades ou para uma entidade específica.',
    scope: {
      title: 'Escopo',
      description: 'A configuração da entidade substitui a configuração geral do tenant.',
      label: 'Aplicar configuração a',
      tenant: 'Todas as entidades do tenant',
      usingTenantFallback: 'Usando a configuração geral do tenant como fallback.',
      usingEntityOverride: 'Usando uma configuração específica desta entidade.',
    },
    execution: {
      title: 'Execução da integração',
      description: 'Quando ativo, o Pipefy poderá criar bills e executar as regras de negócio.',
      label: 'Habilitar execução da integração',
      hint: 'Quando ativo, novos cards poderão criar bills; o Pipefy também poderá aprovar, cancelar e movimentar cards.',
      incomplete: 'Complete as regras de negócio antes de habilitar esta opção.',
      confirmTitle: 'Habilitar execução da integração?',
      confirmDescription:
        'A partir da ativação, novos cards poderão criar bills e os eventos poderão aprovar ou cancelar bills e movimentar cards no Pipefy.',
      confirmCancel: 'Cancelar',
      confirmAction: 'Habilitar execução',
    },
    connection: {
      title: 'Conexão',
      description: 'Use um Service Account token da Pipefy. O token salvo nunca é reapresentado.',
      token: 'Access token',
      tokenPlaceholder: 'Cole o token da Pipefy',
      tokenConfigured: 'Token configurado — informe outro apenas para substituir',
      success: 'Conexão validada',
    },
    webhooks: {
      title: 'Webhooks ativos',
      description: 'URLs atualmente configuradas para receber eventos da Pipefy.',
      tenantScope: 'Todas as entidades do tenant',
      providerId: 'ID no Pipefy: {{id}}',
      notProvisioned: 'não provisionado',
      loading: 'Carregando webhooks ativos',
      empty: 'Nenhum webhook ativo configurado.',
      pendingUrl: 'URL que será configurada na ativação',
    },
    pipe: {
      title: 'Pipe',
      description: 'Descubra os pipes acessíveis e selecione exatamente um.',
      label: 'Pipe selecionado',
      placeholder: 'Selecione um pipe',
      identifierFormat: 'id: {{id}}, suid: {{suid}}',
    },
    mapping: {
      title: 'Mapeamentos',
      description: 'Associe os campos necessários e defina a ação de cada fase.',
      selectField: 'Selecione um campo',
      ignore: 'Ignorar',
      process: 'Disponível para processamento posterior',
      noAttachmentField: 'Nenhum campo — manter o fluxo atual',
      noBillLinkField: 'Nenhum campo — não preencher o link',
      attachmentFieldsGroup: 'Campos de anexo',
      otherFieldsGroup: 'Outros campos',
      billLinkHint:
        'Opcional. Primeiro crie no Pipefy um campo exclusivo de texto curto ou longo; depois selecione-o aqui. Quando o card estiver vinculado a uma bill ativa, o ERP preencherá o link direto da bill.',
      backfillHint: 'Enfileire a atualização dos cards já correlacionados com bills ativas.',
      attachmentsHint:
        'Selecione um ou mais campos de anexo. Se nenhum for selecionado, todos os campos de anexo do card serão usados. A bill pode ser criada sem anexo e receber os documentos depois.',
      customFieldsTitle: 'Campos adicionais para regras',
      customFieldsDescription:
        'Crie aliases para campos do card que serão usados como origem nas regras de entrada. Eles aparecem como custom_<alias>.',
      addCustomField: 'Adicionar campo',
      customFieldKey: 'Nome do campo na regra',
      customFieldKeyPlaceholder: 'Ex.: cnpj_cliente ou regional',
      customFieldSource: 'Campo de origem no Pipefy',
      removeCustomField: 'Remover campo adicional',
      noDepartmentField: 'Nenhum campo — não ler o departamento',
      noCategoryField: 'Nenhum campo — não ler a categoria',
      departmentHint:
        'Opcional. O departamento do card é vinculado ao departamento do ERP com o mesmo nome.',
      categoryHint:
        'Opcional. Selecione um campo ou, se o pipe tiver uma lista de categoria por departamento, todas elas: vale a lista cujo nome termina com o departamento do card. O código da categoria fica disponível nas regras de entrada.',
      fields: {
        taxId: 'CNPJ/CPF',
        amount: 'Valor',
        dueDate: 'Vencimento',
        vendor: 'Fornecedor',
        integratedErp: 'Integrado no ERP',
        attachments: 'Anexos (opcional)',
        billLink: 'Link da bill no ERP (opcional)',
        department: 'Departamento (opcional)',
        category: 'Categoria (opcional)',
      },
    },
    businessRules: {
      title: 'Regras de negócio',
      description: 'Associe cada status do ERP a uma fase real do pipe selecionado.',
      approvalTriggerPhase: 'Disparar aprovação · PENDING_APPROVAL (bill)',
      paymentDayPhase: 'Pagamentos do dia · ajuste da data programada',
      inProgressPhase: 'Pagamento em andamento · PROCESSING (payment)',
      paymentCompletedPhase: 'Pagamento concluído · PAID (payment)',
      analysisPhase: 'Análise · SUBMITTED (bill)',
      cancelledPhase: 'Cancelamento · VOID (bill)',
      selectPhase: 'Selecione uma fase',
      optional: 'Não configurado (opcional)',
      requiredHint: 'As cinco primeiras fases são obrigatórias e devem ser diferentes.',
    },
    events: {
      title: 'Eventos',
      description: 'Selecione os eventos que serão enviados ao inbox autenticado do ERP.',
      fieldUpdate: 'Alteração de campo',
      create: 'Criação de card',
      move: 'Movimentação de card',
      delete: 'Exclusão de card',
      cardMoveRequired: 'O evento de movimentação de card é obrigatório para ativar a integração.',
      intakeRequired:
        'A ingestão de contas a pagar via webhook está ativa e exige os eventos: {{events}}.',
    },
    actions: {
      save: 'Salvar',
      test: 'Testar conexão',
      discover: 'Descobrir metadados',
      activate: 'Ativar',
      deactivate: 'Desativar',
      backfillBillLinks: 'Preencher links existentes',
      retry: 'Tentar novamente',
    },
    statusLabels: {
      CONFIGURING: 'Em configuração',
      ACTIVE: 'Ativa',
      INACTIVE: 'Inativa',
      ERROR: 'Erro',
    },
    footer: { status: 'Status: {{status}}', draft: 'Rascunho não ativado' },
    toasts: {
      saved: 'Configuração salva.',
      connectionSuccess: 'Conexão com a Pipefy validada.',
      discoverySuccess: 'Metadados da Pipefy atualizados.',
      activated: 'Configuração Pipefy ativada.',
      deactivated: 'Configuração Pipefy desativada.',
      billLinksBackfilled:
        'Sincronização enfileirada para {{queued}} vínculos de {{scanned}} registros analisados.',
    },
    errors: {
      load: 'Não foi possível carregar a configuração Pipefy.',
      incomplete:
        'Complete o pipe, os campos obrigatórios, as regras de negócio e habilite a movimentação de card antes de ativar.',
      generic: 'Não foi possível concluir a operação.',
      discovery:
        'Não foi possível carregar os pipes salvos. Tente descobrir os metadados novamente.',
    },
  },
  details: {
    genericIntegration: 'a integração',
    nav: {
      back: 'Voltar',
    },
    status: {
      connected: 'Conectado',
      available: 'Disponível',
    },
    links: {
      website: 'Website',
      docs: 'Documentação',
    },
    actions: {
      syncNow: 'Sincronizar agora',
      syncing: 'Sincronizando...',
      disconnect: 'Desconectar',
    },
    focusNfe: {
      entityLabel: 'Entidade',
      entityPlaceholder: 'Selecione a entidade',
      syncNfe: 'NF-e',
      syncNfse: 'NFS-e',
    },
    onfly: {
      setup: {
        title: 'Conexões OnFly',
        description:
          'Configure uma conexão por entidade. Cada entidade usa o seu próprio par clientId/clientSecret da OnFly.',
        schedule: 'Sincronização automática às {{times}} ({{timezone}}).',
        addEntity: 'Adicionar entidade',
        loading: 'Carregando conexões…',
        empty: 'Nenhuma entidade conectada. Adicione a primeira conexão OnFly.',
        credentialsConfigured: 'Credenciais configuradas',
        credentialsMissing: 'Sem credenciais',
        lastSync: 'Última sync {{date}}',
        neverSynced: 'Nunca sincronizada',
        configure: 'Configurar',
        syncNow: 'Sincronizar agora',
        syncQueued: 'Sincronização OnFly enfileirada.',
        syncError: 'Falha ao enfileirar a sincronização OnFly.',
        autoApproveBadge: 'Aprovação automática',
        createTitle: 'Nova conexão OnFly',
        editTitle: 'Editar conexão OnFly',
        dialogDescription:
          'Selecione a entidade e informe as credenciais da conta OnFly correspondente.',
        entityLabel: 'Entidade',
        entityPlaceholder: 'Selecione a entidade',
        entityAlreadyConnected: 'Esta entidade já possui uma conexão OnFly.',
        credentialsReady:
          'Credenciais configuradas. Use o botão abaixo apenas se precisar rotacioná-las.',
        clientIdLabel: 'Client ID',
        clientSecretLabel: 'Client Secret',
        credentialsPlaceholder: 'Digite para definir/rotacionar',
        rotateCredentials: 'Rotacionar credenciais',
        cancelRotation: 'Cancelar rotação',
        defaultCostCenterLabel: 'Centro de custo padrão',
        defaultCostCenterHint:
          'Usado quando a reserva OnFly não informa centro de custo. Sem ele, essas contas ficam pendentes de classificação.',
        defaultCostCenterPlaceholder: 'Selecione o centro de custo',
        autoSyncLabel: 'Sincronização automática',
        autoSyncHint: 'Quando desativada, apenas sincronizações manuais serão executadas.',
        autoApproveLabel: 'Aprovação automática',
        autoApproveHint:
          'Contas OnFly totalmente classificadas seguem para lançamento sem revisão humana.',
        autoApproveConfirmTitle: 'Liberar aprovação automática?',
        autoApproveConfirmDescription:
          'As faturas OnFly desta entidade passarão a ser aprovadas e contabilizadas sem revisão humana. Desligar depois não desfaz os lançamentos já feitos.',
        autoApproveConfirmAction: 'Liberar sem revisão',
        autoApproveEnabled: 'Aprovação automática habilitada.',
        autoApproveDisabled: 'Aprovação automática desabilitada.',
        autoApproveError:
          'Não foi possível alterar a aprovação automática. É necessária alçada financeira, e quem configurou a integração não pode liberá-la.',
        connect: 'Conectar integração',
        save: 'Salvar configuração',
        loadError: 'Falha ao carregar conexões OnFly.',
        status: {
          ACTIVE: 'Ativa',
          INACTIVE: 'Inativa',
          ERROR: 'Com erro',
        },
        loadFailed:
          'Não foi possível carregar as conexões OnFly. A lista abaixo pode estar incompleta — tente novamente antes de conectar uma entidade.',
        retry: 'Tentar novamente',
        selectEntityError: 'Selecione a entidade.',
        alreadyConnectedError: 'Esta entidade já possui uma conexão OnFly.',
        credentialsRequiredCreate: 'Informe Client ID e Client Secret para conectar a integração.',
        credentialsRequiredRotate:
          'Informe Client ID e Client Secret para rotacionar as credenciais.',
        createSuccess: 'Conexão OnFly criada com sucesso.',
        updateSuccess: 'Conexão OnFly atualizada.',
        saveError: 'Falha ao salvar conexão. Verifique as credenciais.',
        vendorCodeConflict:
          'Já existe um fornecedor com o código ONFLY e outro CNPJ. Nada foi alterado nele; a OnFly foi cadastrada como ONFLY_TRAVEL.',
        discardTitle: 'Descartar alterações?',
        discardDescription:
          'As credenciais digitadas e os ajustes desta conexão serão perdidos. As credenciais não podem ser recuperadas depois.',
        discardConfirm: 'Descartar',
        discardCancel: 'Continuar editando',
      },
      accounts: {
        title: 'Contas por tipo de viagem',
        description:
          'Defina a conta contábil e a conta gerencial usadas em cada tipo de viagem OnFly.',
        entityLabel: 'Entidade',
        entityPlaceholder: 'Selecione a entidade',
        connectFirst: 'Conecte ao menos uma entidade antes de mapear as contas.',
        coaVersion: 'Plano de contas vigente: {{version}}',
        loading: 'Carregando contas…',
        glLabel: 'Conta contábil (despesa)',
        glPlaceholder: 'Selecione a conta contábil',
        managerialLabel: 'Conta gerencial',
        managerialPlaceholder: 'Selecione a conta gerencial',
        incomplete:
          '{{count}} tipo(s) de viagem ainda sem contas. Contas OnFly desses tipos ficam pendentes de classificação.',
        nothingToSave: 'Preencha as duas contas de ao menos um tipo de viagem.',
        saveSuccess: 'Contas por tipo de viagem salvas.',
        saveError: 'Falha ao salvar as contas por tipo de viagem.',
        discardTitle: 'Descartar contas não salvas?',
        discardDescription:
          'As contas contábeis e gerenciais que você escolheu ainda não foram salvas e serão perdidas.',
        loadError: 'Falha ao carregar as contas por tipo de viagem.',
        travelTypeColumn: 'Tipo de viagem',
        replicateColumn: 'Replicar',
        replicateBelow: 'Replicar estas contas para os tipos de viagem abaixo',
        replicateDone_one: 'Contas replicadas para {{count}} tipo de viagem abaixo.',
        replicateDone_other: 'Contas replicadas para {{count}} tipos de viagem abaixo.',
        replicateTitle: 'Substituir as contas dos tipos abaixo?',
        replicateDescription_one:
          '1 tipo de viagem abaixo já tem contas definidas e será substituído. Nada é gravado até você salvar.',
        replicateDescription_other:
          '{{count}} tipos de viagem abaixo já têm contas definidas e serão substituídos. Nada é gravado até você salvar.',
        replicateConfirm: 'Substituir',
        loadFailed:
          'Não foi possível carregar as contas desta entidade. Não edite nem salve as contas agora: você apagaria o mapeamento existente. Tente novamente.',
        retry: 'Tentar novamente',
        save: 'Salvar contas',
        keys: {
          FLIGHT: 'Aéreo',
          HOTEL: 'Hotel',
          RENTAL_CAR: 'Locação de veículo',
          BUS: 'Ônibus',
          CHANGE_FEE: 'Taxa de remarcação',
        },
      },
    },
    contaSimples: {
      autoSyncTitle: 'Autosync ativo',
      autoSyncSchedule:
        'Categorias toda segunda às 03:00. Cartões diariamente às 07:00. Transações em dias úteis às 08:00, 12:00, 16:00 e 20:00.',
      fullSyncSuccess:
        'Sincronização Conta Simples concluída. Categorias: {{categorias}}; cartões: {{cards}}; transações bancárias: {{bankTransactions}}; transações de cartão: {{cardTransactions}}; centros de custo: {{costCenters}}.',
      fullSyncWarning:
        'Sincronização Conta Simples concluída com {{errors}} erro(s). Categorias: {{categorias}}; cartões: {{cards}}; transações bancárias: {{bankTransactions}}; transações de cartão: {{cardTransactions}}; centros de custo: {{costCenters}}.',
      fullSyncError: 'Falha ao executar sincronização completa da Conta Simples.',
      setup: {
        title: 'Conexões Conta Simples',
        description: 'Configure uma integração por entidade (credenciais OAuth e sincronização).',
        addEntity: 'Adicionar entidade',
        loading: 'Carregando conexões…',
        empty: 'Nenhuma entidade conectada. Adicione a primeira conexão Conta Simples.',
        credentialsConfigured: 'Credenciais configuradas',
        credentialsMissing: 'Sem credenciais',
        lastSync: 'Última sync {{date}}',
        configure: 'Configurar',
        createTitle: 'Nova conexão Conta Simples',
        editTitle: 'Editar conexão Conta Simples',
        dialogDescription:
          'Selecione a entidade e informe as credenciais da conta Conta Simples correspondente.',
        entityLabel: 'Entidade',
        entityPlaceholder: 'Selecione a entidade',
        entityAlreadyConnected: 'Esta entidade já possui uma conexão Conta Simples.',
        credentialsReady:
          'Credenciais configuradas. Use o botão abaixo apenas se precisar rotacioná-las.',
        apiKeyLabel: 'API Key',
        apiSecretLabel: 'API Secret',
        credentialsPlaceholder: 'Digite para definir/rotacionar',
        rotateCredentials: 'Rotacionar credenciais',
        cancelRotation: 'Cancelar rotação',
        syncStartDateLabel: 'Data inicial da sincronização (opcional)',
        syncStartDatePlaceholder: 'Selecione a data inicial',
        autoSyncLabel: 'Sincronização automática',
        autoSyncHint: 'Quando desativada, apenas sincronizações manuais serão executadas.',
        autoCreateBillsLabel: 'Criar contas a pagar por anexos',
        autoCreateBillsHint:
          'Usa anexos das transações de cartão para iniciar automaticamente o pipeline de criação de contas.',
        connect: 'Conectar integração',
        save: 'Salvar configuração',
        loadError: 'Falha ao carregar conexões Conta Simples.',
        status: {
          ACTIVE: 'Ativa',
          INACTIVE: 'Inativa',
          ERROR: 'Com erro',
        },
        selectEntityError: 'Selecione a entidade.',
        alreadyConnectedError: 'Esta entidade já possui uma conexão Conta Simples.',
        credentialsRequiredCreate: 'Informe API Key e API Secret para conectar a integração.',
        credentialsRequiredRotate: 'Informe API Key e API Secret para rotacionar as credenciais.',
        createSuccess: 'Conexão Conta Simples criada com sucesso.',
        updateSuccess: 'Conexão Conta Simples atualizada.',
        saveError: 'Falha ao salvar conexão. Verifique as credenciais.',
      },
      dataSync: {
        entitySection: 'Entidade',
        entityPlaceholder: 'Selecione a entidade',
        loadingConnections: 'Carregando…',
        noConnections: 'Nenhuma conexão configurada',
        selectEntityError: 'Selecione a entidade para sincronizar.',
        loadConnectionsError: 'Falha ao carregar conexões Conta Simples.',
        periodSection: 'Período das transações',
        fromLabel: 'Data inicial',
        toLabel: 'Data final',
        invalidPeriod: 'A data inicial não pode ser posterior à data final.',
        sync: 'Sincronizar',
        syncing: 'Sincronizando...',
        categoriasName: 'Categorias',
        categoriasDescription:
          'Importa categorias da Conta Simples para reconciliação com contas gerenciais.',
        categoriasSuccess:
          'Categorias sincronizadas: {{upserted}}/{{fetched}} (erros: {{errors}}).',
        cardsName: 'Cartões corporativos',
        cardsDescription: 'Atualiza a lista de cartões vinculados à conta.',
        cardsEnqueued: 'Sincronização de cartões enfileirada (job {{jobId}}).',
        cardsAlreadyRunning: 'A sincronização de cartões já estava em execução.',
        bankName: 'Transações bancárias',
        bankDescription: 'Importa movimentações da conta digital para o staging.',
        bankEnqueued: 'Sincronização de transações bancárias enfileirada (job {{jobId}}).',
        bankAlreadyRunning: 'A sincronização de transações bancárias já estava em execução.',
        cardTxName: 'Transações de cartão',
        cardTxDescription: 'Importa compras e lançamentos de cartão corporativo.',
        cardTxEnqueued: 'Sincronização de transações de cartão enfileirada (job {{jobId}}).',
        cardTxAlreadyRunning: 'A sincronização de transações de cartão já estava em execução.',
        costCentersName: 'Centros de custo',
        costCentersDescription:
          'Atualiza o snapshot de centros de custo encontrados nas transações.',
        costCentersSuccess: 'Centros de custo detectados no staging: {{count}}.',
        registrationSection: 'Cadastros',
        movementsSection: 'Movimentações',
        dataSourcesSection: 'Fontes de dados',
        cadastralData: 'Dados cadastrais',
        movementsWithPeriod: 'Movimentações',
        movementsPeriodHint: '— usa período acima',
        dimensionsSection: 'Reconciliação de dimensões',
        dimensionsDescription:
          'Mapeie centros de custo e categorias da Conta Simples para a Alchemy ERP.',
        reconcileCategories: 'Reconciliar categorias',
        reconcileCostCenters: 'Reconciliar centros de custo',
      },
    },
    notFound: {
      title: 'Integração não encontrada',
      description: 'A integração solicitada não existe ou foi removida.',
      backAction: 'Voltar para Integrações',
    },
    loadError: {
      title: 'Não foi possível carregar a integração',
      description: 'Verifique sua conexão ou tente novamente em instantes.',
      retry: 'Tentar novamente',
    },
    connectionInfo: {
      title: 'Integração ativa',
      connectedAt: 'Conectado em {{date}}.',
      lastSync: 'Última sincronização: {{relative}}.',
    },
    stats: {
      syncedRecords: 'Registros sincronizados',
      lastSync: 'Última sincronização',
    },
    tabs: {
      sync: 'Data Sync',
      modules: 'Módulos de dados',
      config: 'Configurações',
      webhooks: 'Webhooks',
      activity: 'Atividade',
    },
    config: {
      credentials: {
        title: {
          kamino: 'Credenciais Kamino',
          itau: 'Credenciais Itaú',
          default: 'Credenciais da API',
        },
        description: {
          kamino: 'App, CN, IDUsr, Usr e Hash configurados para autenticação com a Kamino.',
          itau: 'O Client ID OAuth aparece abaixo. Segredo, certificado e chave privada ficam armazenados com criptografia e nunca são exibidos.',
          default: 'Chave de API para autenticação com {{name}}.',
        },
        kaminoLocked:
          'As credenciais (App, CN, IDUsr, Usr, Hash) foram definidas na configuração inicial. Para alterá-las, desconecte a integração e conecte novamente com os novos valores.',
        itau: {
          clientIdLabel: 'Client ID (OAuth)',
          clientIdUnavailable:
            'Não disponível. Atualize as credenciais abaixo com um conjunto completo.',
          secretsStoredNotice:
            'Segredo do cliente, certificado e chave privada estão salvos de forma segura. Não é possível visualizá-los nem baixá-los após o envio.',
          rotateCredentials: 'Substituir credenciais',
          rotateHint:
            'Informe um conjunto completo (Client ID, segredo, certificado PEM, chave privada PEM). Os segredos atuais serão substituídos.',
          saveRotated: 'Salvar novas credenciais',
          requiredFieldsAll: 'Preencha Client ID, segredo, certificado PEM e chave privada PEM.',
        },
        updating: 'Atualizando...',
        updated: 'Credenciais atualizadas com sucesso.',
        updateError: 'Falha ao atualizar credenciais.',
        apiKeyLabel: 'Chave de API',
        apiKeyPlaceholder: 'sk_live_...',
        apiKeyHelper: 'Encontre sua chave de API no painel do {{name}}.',
        webhookSecretLabel: 'Webhook Secret',
        webhookSecretPlaceholder: 'whsec_...',
        webhookSecretDefault: 'whsec_xxxxxxxxxxxxxxxxxxxxxxxx',
        webhookSecretHelper: 'Usado para verificar a autenticidade dos webhooks recebidos.',
        update: 'Atualizar credenciais',
      },
      syncSettings: {
        title: 'Configurações de sincronização',
        description: 'Defina como e quando os dados serão sincronizados.',
        autoSyncLabel: 'Sincronização automática',
        autoSyncHelper: 'Sincronizar dados automaticamente',
        frequencyLabel: 'Frequência de sincronização',
        frequency: {
          realtime: 'Tempo real (webhooks)',
          hourly: 'A cada hora',
          daily: 'Diariamente',
          weekly: 'Semanalmente',
        },
        defaultEntityLabel: 'Entidade padrão',
        entities: {
          main: 'Empresa Principal',
          branchSp: 'Filial São Paulo',
          branchRio: 'Filial Rio de Janeiro',
        },
        defaultEntityHelper: 'Entidade onde os dados serão importados.',
        save: 'Salvar configurações',
      },
      features: {
        title: 'Recursos disponíveis',
        description: 'Funcionalidades disponíveis nesta integração.',
      },
      openFinance: {
        title: 'Sincronização automática',
        description:
          'O Open Finance Brasil sincroniza dados automaticamente conforme os bancos e cartões conectados enviarem transações. Não há configurações de frequência — os dados chegam em tempo quase real via webhooks.',
      },
      itauPayments: {
        title: 'Pagamentos PIX',
        description:
          'O envio usa a API Cash Management (SISPAG v1) do Itaú. É necessário informar no JSON de configuração do tenant o objeto `sispagPagador` (conta débito: agência, conta, CPF/CNPJ, tipo de conta, módulo SISPAG). O cancelamento automático via API não está documentado nesta versão — use o canal bancário se precisar estornar.',
        environmentTitle: 'Ambiente de API',
        environmentDescription:
          'Sandbox e produção usam hosts diferentes por padrão: em sandbox, OAuth e SISPAG ficam sob `api.itau.com.br/sandbox`; em produção, token em `sts.itau.com.br` e API em `api.itau.com.br/sispag/v1`. Você pode sobrescrever STS Base URL e API Base URL na configuração avançada do tenant se o manual de homologação indicar outro endpoint.',
        effectiveApiBaseUrlLabel: 'URL base da API em uso',
        effectiveApiBaseUrlHint:
          'Base SISPAG v1 efetiva (config do tenant ou padrão do ambiente selecionado). Valores antigos `https://api.itau.com.br` sem path são migrados automaticamente para o padrão SISPAG.',
        environmentSelectLabel: 'Ambiente',
        saveEnvironment: 'Salvar ambiente',
        productionWarningTitle: 'Produção',
        productionWarningDescription:
          'Em produção, operações podem movimentar valores reais. Confirme credenciais e contrato com o Itaú.',
      },
      tecnospeed: {
        title: 'Tecnospeed Pagamentos (VAN)',
        subtitle: 'Pagamentos bancários e webhooks',
        description:
          'Após ativar, registre cada conta de origem em Contas bancárias (ação Tecnospeed). O envio em massa na página Pagamentos usa a fila do worker.',
        platformCard: {
          title: 'Credenciais de plataforma',
          description:
            'A conexão Tecnospeed (Pagamento Bancário) no ERP usa o token SH da Alchemy no servidor — não há API key por tenant nesta tela.',
          bullet1:
            'Habilitar o produto no tenant é separado do convênio bancário e das cartas por instituição.',
          bullet2:
            'Cada conta em Contas bancárias pode exigir registro VAN e documentação conforme o banco.',
          bullet3:
            'Se o tenant não estiver ativo aqui, chamadas Tecnospeed para o tenant retornarão erro até a Alchemy liberar.',
          bullet4:
            'Ao ativar, o ERP tenta registrar automaticamente o cedente (pagador) na Tecnospeed para cada entidade com CNPJ de 14 dígitos; contas bancárias e DDA seguem fluxos separados.',
        },
        nextSteps: {
          title: 'Próximos passos',
          description:
            'Cadastre ou edite contas bancárias e conclua a integração Tecnospeed por conta (quando o banco homologar o canal VAN).',
          cta: 'Ir para Contas bancárias',
        },
        letters: {
          title: 'Bancos homologados (canal VAN)',
          description:
            'Instituições com comunicação homologada para o modelo Pagamento Bancário / Tecnospeed. A carta ou fluxo de autorização depende do banco.',
          disclaimerTitle: 'Importante',
          disclaimer:
            'A lista reflete o catálogo público de bancos homologados; contratos, SLA e exigências de carta são sempre definidos pelo banco e pela Tecnospeed.',
          bankCol: 'Código',
          nameCol: 'Instituição',
          tableFoot:
            'Para integrar uma conta, o código do banco precisa estar homologado para VAN. Contas em bancos fora da lista não seguem este canal.',
          guidanceLabel: 'Documentação Pagamento Bancário (Tecnospeed)',
        },
        technical: {
          title: 'Webhooks (técnico)',
          description:
            'URLs para configurar no painel Tecnospeed / Pagamento Bancário quando aplicável. O host vem de VITE_API_URL (ex.: http://localhost:3030/api/v1).',
          paymentsUrl: 'Pagamentos — POST',
          ddaUrl: 'DDA boletos — POST',
          webhookUrl: 'Webhook unificado — POST',
          missingApiBase: 'Defina VITE_API_URL no ambiente do front para exibir URLs completas.',
          webhookHint:
            'O backend pode exigir cabeçalho x-tecnospeed-webhook-secret (TECNOSPEED_WEBHOOK_SECRET) e/ou lista de IPs (TECNOSPEED_WEBHOOK_ALLOWED_IPS).',
        },
        tabs: {
          overview: 'Visão geral',
          banks: 'Bancos e cartas',
          dda: 'DDA',
          webhooks: 'Webhooks',
        },
        onboarding: {
          drawerTitle: 'Configuração do envio de pagamentos',
          drawerDescription:
            'Acompanhe a carta de adesão, o convênio e a ativação por conta bancária.',
          statusLabel: 'Status',
          statuses: {
            NOT_STARTED: 'Não iniciado',
            LETTER_REQUESTED: 'Carta solicitada',
            LETTER_DOWNLOADED: 'Carta baixada',
            LETTER_SENT_TO_MANAGER: 'Carta enviada ao gerente',
            BANK_APPROVED: 'Aprovado pelo banco',
            ACTIVE: 'Ativo',
            ERROR: 'Erro',
          },
          startCta: 'Iniciar carta de adesão',
          downloadLetterCta: 'Baixar carta (.docx)',
          markSentCta: 'Marcar como enviada ao gerente',
          confirmCta: 'Sincronizar agora',
          activateDdaCta: 'Ativar DDA',
          unregisterDdaCta: 'Desativar DDA nesta conta',
          letterMissing:
            'Aguardando template desta instituição. Solicite o arquivo ao time de operações ou consulte a Tecnospeed.',
          letterMissingCta: 'Abrir suporte Tecnospeed',
          enabledProducts: 'Produtos habilitados',
          products: { DDA: 'DDA', PAYMENTS: 'Pagamentos e remessas' },
          manualRemittanceReady: 'Remessa manual pronta',
          agreement: 'Convênio',
          agreementPending: 'Convênio pendente (falta retorno da gerência)',
          agreementContractDate: 'Data do contrato',
          manager: 'Gerente do banco',
          managerName: 'Nome',
          managerContact: 'Contato (e-mail, telefone, WhatsApp)',
          notes: 'Observações',
          saveCta: 'Salvar',
          errorTitle: 'Não foi possível atualizar onboarding',
          ddaRegistered: 'DDA ativo nesta conta',
          ddaInactive: 'DDA inativo',
        },
        ddaReadiness: {
          title: 'Prontidão DDA por conta',
          description:
            'Combina flags do Tecnospeed (ddaActived, VAN) com a carta de adesão enviada pelo ERP.',
          loading: 'Carregando prontidão DDA…',
          loadError: 'Falha ao carregar prontidão DDA',
          syncFlags: 'Sincronizar flags Tecnospeed',
          syncSuccess: 'Flags Tecnospeed atualizadas',
          syncPartial: '{{count}} erro(s) ao sincronizar — veja logs da API',
          syncError: 'Falha ao sincronizar flags Tecnospeed',
          vendorDda: 'DDA no Tecnospeed',
          letterSent: 'Carta DDA enviada',
          van: 'Pagamentos VAN',
          yes: 'Sim',
          no: 'Não',
          unknown: '—',
          level: {
            ready: 'Pronto',
            letter_pending: 'Carta pendente',
            vendor_pending: 'DDA off no Tecnospeed',
            not_registered: 'Conta não registrada',
          },
          ctaLetter: 'Enviar carta no onboarding',
          ctaVendor: 'Verificar com Tecnospeed/banco',
          setupHintTitle: 'Configuração incompleta',
          setupHintBody:
            'Ative DDA no Tecnospeed (ddaActived) e envie a carta assinada por conta bancária. Boletos só chegam quando ambos estiverem ok.',
          bannerTitle: 'DDA ainda não está pronto em todas as contas',
          bannerBody:
            '{{count}} conta(s) com pendência (ex.: {{level}}). Você ainda pode buscar boletos, mas a recepção pode falhar.',
          bannerCta: 'Ver conta bancária',
          subscriptionHeading: 'Consulta de débitos desta empresa',
        },
        ddaInbox: {
          tabTitle: 'Caixa de entrada DDA',
          tabDescription:
            'Boletos DDA recebidos via Tecnospeed. Mirror do padrão FocusNFe: pull → save → list, sem criar contas a pagar automaticamente.',
          openInboxCta: 'Abrir caixa de entrada DDA',
          source: {
            label: 'Origem',
            tecnospeed: 'TecnoSpeed',
            btg: 'BTG',
          },
          btg: {
            description:
              'Boletos que o banco lista contra a empresa. A busca guarda. Vincular usa uma conta a pagar que já existe.',
            fetch: 'Buscar débitos',
            emptyTitle: 'Nenhum débito',
            emptyDescription: 'Busque os débitos quando a conexão da empresa estiver ativa.',
            ignore: 'Ignorar',
            unlink: 'Desvincular',
            link: 'Vincular a conta existente',
            viewBill: 'Ver conta a pagar',
            skipped: 'Algumas empresas não foram consultadas.',
            noSubscriptionTitle: 'Nenhuma empresa aderiu à consulta de débitos',
            noSubscriptionDescription: 'Ative na página de integrações.',
            noSubscriptionCta: 'Abrir integrações',
            subscriptionsLoadError:
              'Não foi possível verificar quais empresas aderiram à consulta de débitos.',
            pageOf: 'Página {{page}} de {{pages}}',
          },
          filters: {
            title: 'Filtros',
            popoverLabel: 'Filtros',
            activeLabel: 'Filtros ativos:',
            clearAll: 'Limpar todos',
            status: 'Status inbox',
            dueRange: 'Vencimento',
            dueFrom: 'Vencimento (de)',
            dueTo: 'Vencimento (até)',
            issuerCnpj: 'CNPJ emissor',
            refresh: 'Atualizar situação DDA',
            fetchBoletos: 'Buscar boletos',
            reload: 'Recarregar lista',
          },
          processingStatus: {
            NEW: 'Novo',
            LINKED_TO_BILL: 'Vinculado',
            BILL_CREATED: 'Conta criada',
            IGNORED: 'Ignorado',
            all: 'Todos',
          },
          commitmentKind: {
            PROPOSAL: 'Proposta',
            COLLECTION: 'Cobrança',
            DEPOSIT: 'Depósito',
            UNKNOWN: 'Indeterminado',
          },
          commitmentKindHint: {
            PROPOSAL: 'Pagamento voluntário — aceitar a proposta ao pagar.',
            COLLECTION: 'Obrigação de cobrança registrada no DDA.',
            DEPOSIT: 'Boleto de depósito ou aporte.',
            UNKNOWN: 'Tipo não informado pelo banco ou registro local.',
          },
          ddaVendorStatus: {
            REGISTERED: 'Registrado',
            PAID: 'Pago',
            CANCELLED: 'Cancelado',
            PROTESTED: 'Protestado',
            REJECTED: 'Rejeitado',
          },
          ddaVendorStatusHint:
            'Situação do boleto no DDA/banco (registrado, pago, cancelado…). Diferente do status inbox, que é o que você já fez no ERP.',
          movimentHint: 'Movimento DDA: {{label}}',
          table: {
            issuer: 'Emissor',
            value: 'Valor',
            dueDate: 'Vencimento',
            commitmentKind: 'Tipo',
            ddaStatus: 'Situação DDA',
            inboxStatus: 'Status inbox',
            actions: 'Ações',
            loading: 'Carregando…',
            emptyTitle: 'Nenhuma cobrança DDA',
            emptyDescription:
              'Quando o DDA estiver ativo na conta bancária, novos boletos aparecerão aqui.',
            linkBill: 'Vincular a conta existente',
            createBill: 'Criar conta a pagar',
            viewBill: 'Ver conta a pagar',
            linkedBill: 'Conta vinculada',
            vendorInErp: 'Fornecedor ERP',
            vendorRegistered: 'Cadastrado',
            vendorNotRegistered: 'Novo CNPJ',
            vendorRegisteredNoBill: 'Sem conta pendente',
            vendorInErpHint:
              'Fornecedor cadastrado com conta a pagar em aberto na mesma entidade — pode vincular ou criar.',
            vendorInErpNoBillHint:
              'Fornecedor já cadastrado, mas não há conta a pagar em aberto (mesma entidade) para vincular. Crie a conta a partir deste boleto.',
            unlink: 'Desvincular',
            ignore: 'Ignorar',
            restore: 'Restaurar',
          },
          unlinkDialog: {
            title: 'Desvincular boleto DDA',
            description:
              'Remove o vínculo com a conta a pagar. Se o pagamento foi criado automaticamente pelo DDA, ele será cancelado.',
          },
          billPanel: {
            suggestionsTitle: 'Boletos DDA sugeridos ({{count}})',
            suggestionTitle: 'Sugestão de boleto DDA',
            emptyMergedTitle: 'Boleto DDA encontrado para esta conta',
            emptyMergedSubtitle:
              'Confira emissor e vencimento. Ao confirmar, criamos o pagamento boleto e vinculamos ao DDA.',
            createPaymentWithDda: 'Criar pagamento com este boleto',
            createPaymentManually: 'Criar pagamento manualmente',
            attachStripTitle: 'Vincular boleto DDA',
            linkToPayment: 'Vincular ao pagamento',
            weakMatchHint: 'Só o valor bateu — confira emissor e vencimento antes de confirmar.',
            openInbox: 'Ver inbox DDA',
            useBoleto: 'Usar este boleto',
            attached: 'Boleto DDA vinculado',
            paymentCreated: 'Boleto DDA vinculado e pagamento criado',
            linkedOnly: 'Boleto vinculado (pagamento não criado — conta aprovada ou sem slot)',
            attachError: 'Falha ao vincular boleto DDA',
            unlink: 'Desvincular',
            unlinked: 'Vínculo DDA removido',
            unlinkedWithPayment: 'Vínculo removido e pagamento automático cancelado',
            unlinkedManualKept: 'Vínculo DDA removido (pagamento manual mantido)',
            unlinkError: 'Falha ao desvincular',
            unlinkDialogBillDescription:
              'Remove o vínculo DDA. Pagamentos criados manualmente não são excluídos.',
          },
          pagination: {
            total: 'Total: {{count}}',
            previous: 'Anterior',
            next: 'Próxima',
            page: 'Página {{page}} de {{total}}',
          },
          linkSheet: {
            title: 'Vincular a conta a pagar',
            description: 'Busque a conta existente que corresponde a este boleto.',
            boletoLabel: 'Boleto selecionado',
            hint: 'Sugestões pelo valor, vencimento e fornecedor do boleto.',
            searchPlaceholder: 'Não achou? Busque por descrição ou fornecedor…',
            suggestionsTitle: 'Correspondências prováveis',
            othersTitle: 'Outras contas ({{count}})',
            matchReason: {
              amount: 'Valor',
              dueDate: 'Vencimento',
              vendor: 'Fornecedor',
            },
            noBills: 'Nenhuma conta encontrada.',
            noBillsCreateHint:
              'Se a conta ainda não existe, crie a partir deste boleto — o fornecedor será provisionado se necessário.',
            createBill: 'Criar conta a pagar',
            cancel: 'Cancelar',
            confirm: 'Vincular',
          },
          createBillModal: {
            title: 'Criar conta a partir do boleto DDA',
          },
          loadErrorTitle: 'Não foi possível carregar a caixa DDA',
          loadErrorForbidden:
            'Você não tem permissão para consultar os boletos DDA. Solicite acesso ao administrador.',
          loadErrorIntegrationInactive:
            'A integração Tecnospeed não está ativa nesta organização. Configure a integração para consultar os boletos DDA.',
          loadErrorTimeout:
            'A API demorou para responder (provável reinício do servidor). Recarregue a página; se persistir, reinicie pnpm dev:stack.',
          toasts: {
            ignored: 'Boleto ignorado',
            linked: 'Vinculado à conta a pagar',
            linkedWithPayment: 'Vinculado e pagamento boleto criado',
            linkedOnly: 'Vinculado (sem pagamento — verifique status da conta)',
            createdAndLinked: 'Conta criada e boleto vinculado',
            createdAndLinkedWithPayment: 'Conta criada, boleto vinculado e pagamento criado',
            createLinkError: 'Conta criada, mas falha ao vincular o boleto DDA',
            fetchUpserted: '{{count}} boleto(s) importado(s) da Tecnospeed',
            fetchNone: 'Nenhum boleto novo no período consultado',
            fetchSkipped: 'DDA inativo ou cedente não pronto — configure na aba DDA da integração',
            fetchError: 'Falha ao buscar boletos na Tecnospeed',
            linkWarning: {
              amount_divergence: 'Atenção: valor da conta difere do boleto DDA',
              due_date_divergence: 'Atenção: vencimento da conta difere do boleto DDA',
              barcode_divergence: 'Atenção: código de barras não confere',
            },
            unlinked: 'Vínculo removido',
            unlinkedWithPayment: 'Vínculo removido e pagamento automático cancelado',
            ignoreError: 'Falha ao ignorar',
            restoreError: 'Falha ao restaurar',
            linkError: 'Falha ao vincular',
            unlinkError: 'Falha ao desvincular',
            loadError: 'Falha ao carregar a caixa DDA',
            statusSyncChanged: '{{count}} boleto(s) com situação DDA atualizada',
            statusSyncNone: 'Não foi possível consultar situações no banco',
          },
        },
        webhooks: {
          tabTitle: 'Registros de webhook',
          tabDescription:
            'Subscriptions ativas no painel Tecnospeed. Use o botão para registrar/refrescar quando mudar de ambiente.',
          refreshCta: 'Registrar/atualizar webhooks',
          empty: 'Nenhum webhook registrado ainda.',
          statusActive: 'Ativo',
          statusDisabled: 'Desativado',
          statusError: 'Erro',
          tunnelAlertTitle: 'Túnel público necessário (dev local)',
          tunnelAlertBody:
            'A Tecnospeed não consegue POSTar em localhost. Exponha a API local com cloudflared ou ngrok e cole a URL pública abaixo (terminando em /api/v1).',
          tunnelHint:
            'pnpm tunnel:prod-local-api  →  copie a URL  →  reinicie a API  →  registre webhooks',
          publicBaseLabel: 'URL pública da API (webhooks)',
          publicBaseHelper:
            'Navegador continua em {{browserApi}}; só os webhooks usam a URL pública. Ou defina PUBLIC_API_BASE_URL no .env da API.',
          tunnelRequired:
            'Informe a URL pública do túnel (terminando em /api/v1) antes de registrar.',
          secretConfigured: 'TECNOSPEED_WEBHOOK_SECRET está configurado nesta API.',
          secretNotConfigured:
            'TECNOSPEED_WEBHOOK_SECRET não está definido (ok em dev; obrigatório em produção).',
          unifiedHint:
            'PlugBank envia pagamentos e DDA para a mesma URL; o backend roteia pelo campo happen / formato do payload.',
        },
      },
    },
    activity: {
      title: 'Log de atividades',
      description: 'Histórico de sincronizações, webhooks e eventos da integração.',
      emptyTitle: 'Nenhuma atividade registrada',
      emptyDescription: 'Atividades aparecerão aqui após a primeira sincronização',
      viewFullHistory: 'Ver histórico completo',
    },
    disconnect: {
      title: 'Desconectar {{name}}?',
      description:
        'Esta ação irá remover a conexão com {{name}}. Os dados já sincronizados serão mantidos, mas novas sincronizações não serão realizadas.',
      defaultIntegration: 'esta integração',
    },
    relativeTime: {
      justNow: 'agora mesmo',
      minutesAgo: 'há {{count}} min',
      hoursAgo: 'há {{count}}h',
      daysAgo: 'há {{count}} dias',
    },
    toasts: {
      kaminoSyncSuccess: 'Sincronização de clientes concluída',
      kaminoSyncError: 'Falha ao sincronizar clientes com a Kamino',
      focusNfeEntityRequired: 'Selecione uma entidade para sincronizar',
      focusNfeSyncQueued: 'Sincronização enfileirada',
      focusNfeSyncQueuedWithCount_one: 'Sincronização enfileirada ({{count}} job)',
      focusNfeSyncQueuedWithCount_other: 'Sincronização enfileirada ({{count}} jobs)',
      focusNfeSyncError: 'Falha ao enfileirar sincronização do Focus NFe',
      integrationConfigured: 'Integração configurada com sucesso!',
      itauEnvironmentSaved: 'Ambiente Itaú atualizado.',
      itauEnvironmentError: 'Não foi possível atualizar o ambiente Itaú.',
      integrationConfigError: 'Falha ao configurar a integração. Verifique suas credenciais.',
      modulesSaved: 'Configurações de módulos salvas',
      modulesSaveError: 'Falha ao salvar configurações',
    },
  },
  focusNfe: {
    loading: {
      entities: 'Carregando entidades...',
    },
    errors: {
      loadTitle: 'Falha ao carregar',
    },
    status: {
      active: 'ATIVO',
      error: 'ERRO',
      pending: 'PENDENTE',
      certificatePending: 'CERTIFICADO PENDENTE',
      suspended: 'SUSPENSO',
      notConfigured: 'NÃO CONFIGURADO',
    },
    testData: {
      title: 'Test data habilitado',
      description: 'Você pode testar a sincronização com uma empresa pré-configurada.',
      cnpj: '(CNPJ: {{cnpj}}).',
      environment: 'Ambiente: {{environment}}.',
    },
    summary: {
      configured: '{{configured}}/{{total}} entidade(s) configurada(s)',
    },
    actions: {
      refresh: 'Atualizar',
      testSync: 'Testar sync',
      testSyncTitle: 'Enfileira sync usando token/CNPJ do ambiente de teste',
      syncAll: 'Sincronizar todas',
      syncAllTitle: 'Enfileira sincronização para todas as entidades configuradas',
      updateCertificate: 'Editar configurações',
      configure: 'Configurar',
    },
    entity: {
      cnpj: 'CNPJ: {{cnpj}}',
      cnpjMissing: 'CNPJ não informado',
      certificate: 'Certificado',
      expiresAt: 'Expira em',
      lastSync: 'Última sincronização',
      receivedNfs: 'NFs recebidas',
      errorTitle: 'Erro',
    },
    modules: {
      nfe: {
        label: 'NF-e',
        description: 'SEFAZ (NSU)',
      },
      nfse: {
        label: 'NFS-e',
        description: 'Municipal/legado',
      },
      nfsen: {
        label: 'NFS-e Nacional',
        description: 'Padrão nacional',
      },
      emissaoNfe: {
        label: 'Emissão de NFe',
        description: 'Habilita a emissão de NF-e no ERP',
      },
      emissaoNfce: {
        label: 'Emissão de NFC-e',
        description: 'Habilita emissão de nota fiscal ao consumidor.',
      },
      emissaoNfcom: {
        label: 'Emissão de NFCom',
        description: 'Habilita emissão de nota fiscal de comunicação.',
      },
      emissaoDce: {
        label: 'Emissão de DC-e',
        description: 'Habilita emissão de declaração de conteúdo eletrônica.',
      },
      emissaoNfseMunicipal: {
        label: 'Emissão de NFS-e Municipal',
        description: 'Habilita emissão pelo provedor municipal/legado.',
      },
      emissaoNfse: {
        label: 'Emissão de NFS-e Nacional',
        description: 'Habilita a emissão pelo ambiente nacional da NFS-e.',
      },
      emissaoCte: {
        label: 'Emissão de CT-e',
        description: 'Habilita emissão de conhecimento de transporte.',
      },
      emissaoMdfe: {
        label: 'Emissão de MDF-e',
        description: 'Habilita emissão de manifesto eletrônico de documentos fiscais.',
      },
      recebimentoNfe: {
        label: 'Recebimento de NFe',
        description: 'Busca diariamente NF-e recebidas pela empresa',
      },
      recebimentoNfse: {
        label: 'Recebimento de NFS-e',
        description: 'Busca diariamente NFS-e recebidas pela empresa',
      },
    },
    setup: {
      title: 'Configurar entidade no Focus NFe',
      description:
        'Confirme os dados da entidade e, se necessário, envie o certificado digital A1 (.pfx/.p12).',
      certificateSafety: {
        title: 'Atualização segura do certificado',
        description:
          'Salvar configurações não altera o certificado atual. O certificado e a senha só são atualizados quando você seleciona um novo arquivo (.pfx/.p12) e informa a senha.',
      },
      productionLocked: {
        title: 'Configurações de emissão protegidas',
        description:
          'Módulos, séries e credenciais continuam preservados no Focus NFe. Somente a próxima sequência RPS pode ser ajustada abaixo.',
      },
      sequenceSettings: {
        label: 'Próxima sequência RPS',
        description:
          'NFS-e municipal e NFS-e nacional usam sequências independentes. Por segurança, a sequência só pode avançar.',
        municipal: 'Próximo RPS municipal',
        national: 'Próximo RPS nacional',
        advance: 'Avançar sequência',
        saveBlockedByPendingChange:
          'Avance a sequência RPS ou desfaça a alteração antes de salvar as demais configurações.',
        confirmTitle: 'Confirmar alteração da sequência RPS?',
        confirmDescription:
          'A próxima emissão usará a nova sequência. Confirme que o número ainda não foi utilizado na prefeitura.',
        reasonLabel: 'Motivo da alteração',
        reasonPlaceholder: 'Ex.: alinhar com a sequência atual da prefeitura',
        cancel: 'Voltar',
        confirm: 'Alterar sequência',
      },
      sections: {
        company: 'Dados da empresa',
        modules: 'Módulos da integração',
        address: 'Endereço (opcional)',
        certificate: 'Certificado digital (opcional)',
      },
      fields: {
        legalName: {
          label: 'Razão social',
          placeholder: 'Razão Social Ltda',
        },
        companySource: {
          label: 'Dados cadastrais da entidade',
          description:
            'Esses campos são gerenciados na Entidade e sincronizados automaticamente com o Focus NFe.',
          action: 'Editar na Entidade',
        },
        companyConfirm: {
          description: 'Confirme os dados da empresa abaixo antes de continuar com a configuração.',
        },
        tradeName: {
          label: 'Nome fantasia',
          placeholder: 'Nome Fantasia',
        },
        cnpj: {
          label: 'CNPJ',
          placeholder: '11222333000181',
        },
        taxRegime: {
          label: 'Regime tributário',
          description: 'Sugestão baseada nas configurações fiscais da empresa.',
          placeholder: 'Selecione...',
          clear: 'Não informar',
          loading: 'Carregando regime fiscal sugerido...',
        },
        stateRegistration: {
          label: 'Inscrição estadual',
          optional: 'Opcional',
          placeholder: '1234567890',
        },
        municipalRegistration: {
          label: 'Inscrição municipal',
          optional: 'Opcional',
          placeholder: '12345',
        },
        modules: {
          label: 'Emissão de documentos',
          description:
            'Configure os documentos fiscais de emissão. Campos de série e próximo número usam os campos de produção do Focus NFe.',
        },
        receivingModules: {
          label: 'Recebimento de documentos',
          description:
            'Configure os documentos fiscais recebidos e o processamento automático para contas a pagar.',
        },
        emissionSettings: {
          label: 'Configurações de emissão',
          description:
            'Opções aplicadas ao ambiente de produção do Focus NFe, inclusive quando o endpoint ativo é homologação.',
        },
        sendEmailToRecipient: {
          label: 'Enviar email ao destinatário',
          description: 'Envia email ao destinatário/tomador após a emissão.',
        },
        discriminateTaxes: {
          label: 'Discriminar impostos',
          description: 'Calcula impostos aproximados para NF-e e NFC-e.',
        },
        showDanfseBadge: {
          label: 'Mostrar badge Focus NFe na DANFS-e',
          description: 'Exibe o distintivo Focus na DANFS-e emitida.',
        },
        emission: {
          series: 'Série',
          seriesPlaceholder: '1',
          nextNumber: 'Próximo número',
          nextRps: 'Próximo RPS',
          nextNumberPlaceholder: '1',
          synchronousDescription: 'Autoriza/rejeita na mesma requisição quando suportado.',
        },
        nfeSynchronous: {
          label: 'Utiliza envio síncrono - NFe',
        },
        mdfeSynchronous: {
          label: 'Utiliza envio síncrono - MDF-e',
        },
        prefeituraLogin: {
          label: 'Login da prefeitura',
          placeholder: 'Login prefeitura',
        },
        prefeituraPassword: {
          label: 'Senha da prefeitura',
          placeholder: 'Senha prefeitura',
        },
        nfeRecebimentoStartDate: {
          description:
            'Data de início para buscar NF-e recebidas. A SEFAZ disponibiliza apenas os últimos 90 dias.',
          locked:
            'Data de início definida na primeira habilitação e fixada na Focus NFe. Alterá-la aqui não refaz a busca — NF-e anteriores precisam de importação manual do XML.',
          maybeKept:
            'Data de início para buscar NF-e recebidas, aplicada apenas se esta empresa for nova na Focus NFe. Se já existir empresa para este CNPJ recebendo NF-e, ela é adotada e a data dela é mantida. A SEFAZ disponibiliza apenas os últimos 90 dias.',
        },
        processAsApFrom: {
          description:
            'Gerar contas a pagar automaticamente apenas para NFs recebidas a partir desta data.',
          cardLabel: 'Gerar contas a pagar a partir de',
          cardDescription: 'NFs anteriores continuam importadas, mas não geram bills automáticas.',
        },
        autoProcessReceivedNfs: {
          label: 'Processar NF-es e NFS-es automaticamente',
          description:
            'Quando desativado, as notas continuam sendo importadas, mas não geram contas a pagar automaticamente.',
          cardDescription:
            'Habilite para que os agentes de IA automaticamente processem NFs recebidas e gerem contas a pagar ou sejam vinculadas à contas existentes.',
        },
        nfseForcedEmissionMode: {
          label: 'Modo de emissão NFS-e',
          description:
            'Automático usa o roteamento do município. Force Nacional ou Municipal quando necessário.',
          cardLabel: 'Emissão NFS-e',
          cardDescription: 'Define se a emissão usa o ambiente Nacional ou Municipal (legado).',
          automatic: 'Automático',
          nacional: 'Nacional',
          municipal: 'Municipal',
        },
        addressStreet: {
          label: 'Logradouro',
          placeholder: 'Rua Exemplo',
        },
        addressNumber: {
          label: 'Número',
          placeholder: '100',
        },
        addressDistrict: {
          label: 'Bairro',
          placeholder: 'Centro',
        },
        addressCity: {
          label: 'Município',
          placeholder: 'São Paulo',
        },
        addressState: {
          label: 'UF',
          placeholder: 'SP',
        },
        addressPostalCode: {
          label: 'CEP',
          description:
            'Informe o CEP e clique em buscar para preencher o endereço automaticamente.',
          placeholder: '01000-000',
          lookup: 'Buscar endereço pelo CEP',
          invalidCep: 'CEP deve ter 8 dígitos',
          cepNotFound: 'CEP não encontrado',
          cepFound: 'Endereço preenchido com sucesso',
          cepLookupError: 'Falha ao buscar CEP',
        },
        certificateFile: {
          label: 'Certificado A1 (.pfx/.p12)',
          description: 'Opcional. Sem certificado a empresa fica pendente.',
          helper:
            'O arquivo será enviado em base64 para criação/atualização da empresa no Focus NFe.',
        },
        certificatePassword: {
          label: 'Senha do certificado',
          placeholder: 'Informe a senha do certificado',
        },
      },
      actions: {
        uploadCertificate: 'Enviar certificado',
        uploadingCertificate: 'Enviando...',
        saveCompany: 'Salvar',
        savingCompany: 'Salvando...',
      },
      errors: {
        readFile: 'Falha ao ler o arquivo',
        invalidFileResult: 'Resultado inválido ao ler o arquivo',
        loadConfiguration: 'Falha ao carregar configuração do Focus NFe',
      },
      validation: {
        certificateFileRequired: 'Selecione o arquivo do certificado (.pfx/.p12)',
        certificatePasswordRequired: 'Informe a senha do certificado',
        processAsApFromRequired:
          'Informe a data a partir da qual NF-es e NFS-es serão processadas automaticamente.',
        nfeRecebimentoStartDateRequired:
          'Informe a data inicial de recebimento de NF-e para continuar.',
        nfeRecebimentoStartDateTooOld:
          'A SEFAZ disponibiliza apenas os últimos 90 dias de NF-e recebidas. Notas anteriores precisam de importação manual do XML.',
        nextRpsInvalid: 'O próximo RPS deve ser um número inteiro maior que zero.',
        rpsChangeReasonRequired: 'Informe o motivo da alteração da sequência RPS.',
      },
      toasts: {
        fiscalConfigError: 'Falha ao carregar regime fiscal da empresa',
        modulesUpdated: 'Módulos atualizados',
        modulesUpdateError: 'Falha ao atualizar módulos',
        testSyncQueued: 'Sync de teste enfileirado',
        testSyncError: 'Falha ao enfileirar sync de teste',
        allSyncQueued_one: '{{count}} sincronização enfileirada.',
        allSyncQueued_other: '{{count}} sincronizações enfileiradas.',
        allSyncError_one: 'Falha ao enfileirar {{count}} sincronização.',
        allSyncError_other: 'Falha ao enfileirar {{count}} sincronizações.',
        allSyncGenericError: 'Falha ao enfileirar sincronização para todas as entidades.',
        autoProcessEnabled: 'Processamento automático ativado.',
        autoProcessDisabled: 'Processamento automático desativado.',
        autoProcessUpdateError: 'Falha ao atualizar processamento automático.',
        autoProcessStartDateUpdated: 'Data inicial do processamento automático atualizada.',
        autoProcessStartDateUpdateError:
          'Falha ao atualizar data inicial do processamento automático.',
        emissionModeUpdated: 'Modo de emissão NFS-e atualizado.',
        emissionModeUpdateError: 'Falha ao atualizar modo de emissão NFS-e.',
        companySaved: 'Empresa configurada. Certificado pendente.',
        companyUpdated: 'Empresa atualizada no Focus NFe. Certificado mantido.',
        certificateUploaded: 'Certificado enviado e empresa configurada no Focus NFe',
        companySaveError: 'Falha ao configurar entidade no Focus NFe',
        emissionSettingsLoadError: 'Falha ao carregar a sequência RPS do Focus NFe.',
        rpsSequenceAdvanced: 'Sequência RPS avançada no Focus NFe.',
        rpsSequenceAdvanceError: 'Falha ao avançar a sequência RPS no Focus NFe.',
      },
    },
  },
  dimensionReconciliation: {
    title: 'Mapeamento de integrações',
    subtitle: 'Mapeie dimensões internas com integrações externas.',
    tabs: {
      costCenters: 'Centros de custo',
      departments: 'Departamentos',
      managerialAccounts: 'Contas gerenciais',
    },
    dimensions: {
      costCenter: 'Centro de custo',
      department: 'Departamento',
      managerialAccount: 'Conta gerencial',
    },
    stats: {
      mapped: 'mapeados',
      suggested: 'sugeridos',
      conflicts: 'conflitos',
      unmapped: 'sem mapeamento',
    },
    actions: {
      generateSuggestions: 'Gerar sugestões',
      acceptAll: 'Aceitar todas ({{count}})',
    },
    banner: {
      message: '{{count}} sugestões de mapeamento encontradas. Revise ou aceite todas de uma vez.',
      reconciling: 'Gerando sugestões com IA. Isso pode levar alguns segundos...',
    },
    filters: {
      all: 'Todas',
      searchPlaceholder: 'Buscar por nome, código ou entidade...',
      statusLabel: 'Status',
      statusAll: 'Todos',
      statusActive: 'Ativos',
      statusInactive: 'Inativos',
      pendingOnly: 'Somente pendentes',
      entityLabel: 'Entidade',
      entityPlaceholder: 'Selecione a entidade',
    },
    columns: {
      internal: 'Alchemy',
      notSupported: 'Não suportado',
    },
    sync: {
      aria: 'Sincronizar itens externos',
      tooltip: 'Buscar itens da integração',
    },
    cell: {
      inactive: 'Inativo',
      mapped: 'Mapeado',
      suggested: 'Sugestão',
      conflict: 'Conflito',
      conflictCount: '{{count}} candidatos',
      accept: 'Aceitar',
      reject: 'Rejeitar',
      map: 'Mapear',
      edit: 'Alterar',
      remove: 'Desvincular',
      primary: 'Principal',
      setPrimary: 'Definir principal',
      setPrimaryTooltip:
        'O valor selecionado como principal será utilizado para a correlação dessa dimensão ao enviar dados de novo para a origem',
    },
    delete: {
      confirm: 'Escolha como deseja remover este vínculo:',
      selected: 'Remover este vínculo',
      all: 'Remover todos',
    },
    unmatched: {
      title: 'Itens externos sem correspondência',
      subtitle: 'Itens encontrados nas integrações sem equivalente interno.',
      suggested: 'Sugestão',
      empty: 'Nenhum item pendente',
      create: 'Criar {{dimensionLabel}}',
    },
    empty: {
      externalItems: 'Nenhum item disponível',
    },
    errors: {
      loadMatrix: 'Erro ao carregar matriz de reconciliação.',
    },
    toasts: {
      suggestionsReady: 'Sugestões geradas com sucesso',
      suggestionsError: 'Erro ao gerar sugestões',
      noSuggestions: 'Nenhuma sugestão disponível',
      acceptedAll: 'Sugestões aplicadas com sucesso',
      acceptAllError: 'Erro ao aplicar sugestões',
      mappingCreated: 'Mapeamento criado',
      mappingRemoved: 'Mapeamento removido',
      mappingError: 'Erro ao atualizar mapeamento',
      primaryUpdated: 'Mapeamento principal atualizado',
      selectEntity: 'Selecione uma entidade para criar',
      createdFromExternal: 'Dimensão criada a partir do item externo',
      createError: 'Erro ao criar dimensão',
      syncSuccess: 'Itens externos sincronizados',
      syncError: 'Erro ao sincronizar itens externos',
    },
    loading: 'Atualizando...',
    view: {
      matrix: 'Matriz',
    },
  },
  clara: {
    credentials: {
      title: 'Credenciais Clara',
      description:
        'Configure as credenciais OAuth e certificados mTLS para conectar com a API Clara.',
      clientId: 'Client ID',
      clientIdPlaceholder: 'Informe o client ID OAuth',
      clientSecret: 'Client Secret',
      clientSecretPlaceholder: 'Informe o Client Secret OAuth',
      showSecret: 'Mostrar segredo',
      hideSecret: 'Ocultar segredo',
      importJson: 'Importar JSON',
      importJsonDescription:
        'Importe o arquivo .json fornecido pela Clara para preencher todos os campos automaticamente.',
      importJsonButton: 'Importar arquivo .json',
      importJsonSuccess: 'Credenciais importadas do JSON com sucesso.',
      importJsonError: 'Arquivo JSON inválido. Verifique o formato e tente novamente.',
      orManual: 'ou preencha manualmente',
      certificates: 'Certificados mTLS',
      certificatesHint: 'Já preenchidos pelo JSON. Use os campos abaixo apenas para substituir.',
      clientCert: 'Certificado do Cliente (.crt)',
      clientKey: 'Chave Privada (.key)',
      save: 'Salvar Credenciais',
      testConnection: 'Testar Conexão',
      connectedTitle: 'Conexão Clara',
      connectedDescription: 'As credenciais OAuth e certificados mTLS estão configurados.',
      resetConnection: 'Resetar Conexão',
      resetConfirmTitle: 'Resetar conexão Clara?',
      resetConfirmDescription:
        'Isso removerá as credenciais OAuth e os certificados mTLS armazenados. Você precisará configurar a conexão novamente para sincronizar cartões e transações.',
      resetConfirmAction: 'Sim, resetar',
      resetConfirmCancel: 'Cancelar',
    },
    sync: {
      title: 'Sincronização',
      description:
        'Sincronize cartões e transações manualmente ou aguarde a sincronização automática.',
      autoSyncLabel: 'Sincronização Automática',
      autoSyncHelper:
        'Quando desabilitado, cartões e transações só serão sincronizados manualmente.',
      autoCreateBillsLabel: 'Criar contas a pagar a partir de anexos',
      autoCreateBillsHelper:
        'Baixar comprovantes anexados às transações Clara e criar contas a pagar automaticamente.',
      extractedDocumentEnrichmentLabel: 'Usar dados extraídos pela Clara',
      extractedDocumentEnrichmentHelper:
        'Opcional. Faz uma consulta adicional à Clara por transação com anexo para enriquecer a classificação.',
      loadingConfig: 'Carregando configurações de sincronização da Clara',
      cards: 'Sincronizar Cartões',
      transactions: 'Sincronizar Transações',
      scheduleInfo:
        'Cartões são sincronizados diariamente às 07:00. Transações são sincronizadas diariamente às 08:00.',
    },
    entities: {
      title: 'Conexões Clara por empresa',
      description:
        'Cada empresa usa a Clara do seu país. As mesmas credenciais podem ser usadas em várias empresas.',
      loading: 'Carregando empresas',
      loadError: 'Falha ao carregar as conexões Clara.',
      empty: 'Nenhuma empresa cadastrada.',
      market: 'Clara {{country}} · {{currency}}',
      taxId: '{{type}} {{value}}',
      taxIdMissing: 'Cadastre o {{type}} da empresa para conectar a Clara.',
      countryUnavailable: 'A Clara não está disponível neste país.',
      notConnected: 'Não conectada',
      lastSync: 'Última sincronização: {{date}}',
      neverSynced: 'Ainda não sincronizada',
      lastError: 'Último erro: {{message}}',
      connect: 'Conectar',
      replaceCredentials: 'Trocar credenciais',
      connectTitle: 'Conectar Clara — {{entity}}',
      replaceTitle: 'Trocar credenciais Clara — {{entity}}',
      dialogDescription:
        'Esta empresa usa a Clara {{country}}. Informe as credenciais OAuth e os certificados mTLS.',
      status: {
        ACTIVE: 'Ativa',
        INACTIVE: 'Inativa',
        ERROR: 'Com erro',
      },
    },
    errors: {
      entityNotFound: 'Empresa não encontrada.',
      countryUnsupported: 'A Clara não está disponível no país desta empresa.',
      taxIdMissing: 'A empresa não tem o documento fiscal do seu país (CNPJ, RFC ou NIT).',
      connectionNotFound: 'A Clara não está conectada para esta empresa.',
      connectionInactive:
        'A conexão Clara desta empresa está inativa. Informe as credenciais de novo.',
      credentialsMissing: 'Informe as credenciais Clara para conectar esta empresa.',
      credentialsRejected:
        'A Clara recusou as credenciais ou o certificado. Troque as credenciais desta empresa.',
      apiUnavailable: 'A Clara está indisponível agora. A sincronização tenta de novo sozinha.',
      syncFailed: 'A sincronização com a Clara falhou.',
    },
    toasts: {
      credentialsSaved: 'Credenciais Clara salvas com sucesso.',
      credentialsError: 'Falha ao salvar credenciais Clara.',
      connectionSuccess: 'Conexão com Clara estabelecida com sucesso!',
      connectionFailed: 'Falha na conexão com Clara. Verifique suas credenciais.',
      cardSyncEnqueued: 'Sincronização de cartões iniciada.',
      cardSyncAlreadyRunning: 'Sincronização de cartões já em andamento.',
      transactionSyncEnqueued: 'Sincronização de transações iniciada.',
      transactionSyncAlreadyRunning: 'Sincronização de transações já em andamento.',
      syncError: 'Falha ao iniciar sincronização.',
      resetSuccess: 'Conexão Clara resetada com sucesso.',
      resetError: 'Falha ao resetar conexão Clara.',
      settingsError: 'Falha ao salvar configurações da Clara.',
    },
  },
  fiscalApiPdfBranding: {
    title: 'Marca do PDF',
    description:
      'Logo e cores do PDF dos CFDIs emitidos por esta entidade. Valem para os PDFs gerados a partir de agora; o XML (documento fiscal) não muda. Para aplicar a um CFDI já emitido, use "Regerar PDF" em Notas fiscais emitidas.',
    logo: 'Logo',
    logoHint: 'PNG ou JPEG, até 500 KB.',
    logoPreviewAlt: 'Logo do PDF',
    noLogo: 'Sem logo',
    chooseLogo: 'Enviar logo',
    replaceLogo: 'Trocar logo',
    removeLogo: 'Remover logo',
    bandColor: 'Cor da faixa',
    fontColor: 'Cor da fonte',
    colorPicker: 'Seletor de cor',
    colorPlaceholder: '#RRGGBB',
    colorInvalid: 'Use o formato #RRGGBB.',
    colorDefault: 'Vazio usa o padrão do provedor.',
    save: 'Salvar cores',
    toasts: {
      saved: 'Marca do PDF salva',
      logoSaved: 'Logo enviado',
      logoRemoved: 'Logo removido',
      logoType: 'O logo deve ser PNG ou JPEG.',
      logoSize: 'O logo deve ter no máximo 500 KB.',
    },
  },
} as const;

export const integrationsEn = {
  itauBoleto: {
    discardTitle: 'Discard changes?',
    discard: 'Discard',
    keepEditing: 'Keep editing',
    certificateInvalid:
      'Invalid certificate, private key or passphrase. Check the files and passphrase.',
    certificateRequired:
      'Provide the certificate and private key together. Both are required in production.',
    credentialsInvalid: 'Enter a valid Client ID and Client secret.',
    tooLong: 'Use up to {{count}} characters.',
    discardHint: 'Unsaved credential changes will be discarded.',
    accountPermission: 'Request bank account read access to register notifications.',
    entity: 'Entity',
    selectEntity: 'Select an entity',
    selectEntityHint: 'Choose the entity that will issue boletos.',
    noPermission: 'Configuration access unavailable',
    noPermissionHint: 'Request permission to manage integrations.',
    noEntities: 'No entities available',
    noEntitiesHint: 'Create an entity to configure boleto issuance.',
    credentials: 'Itaú boleto credentials',
    replaceHint:
      'Saving replaces all credentials for this entity. Enter the secret again and, if used, the certificate and private key.',
    requiredLegend: 'required',
    required: 'Complete this field.',
    proposedClientIdRequired: 'Enter the client ID',
    proposedClientSecretRequired: 'Enter the client secret',
    proposedCertificateRequired:
      'Enter the certificate when the environment is production or certificate details are provided',
    proposedPrivateKeyRequired:
      'Enter the private key when the environment is production or certificate details are provided',
    environment: 'Environment',
    sandbox: 'Sandbox',
    production: 'Production',
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    certificate: 'Digital certificate',
    certificateHint:
      'Production requires a matching certificate and private key. Saved credentials are never displayed.',
    certificatePem: 'PEM certificate',
    privateKeyPem: 'PEM private key',
    passphrase: 'Private key password',
    webhook: 'Payment notifications',
    webhookHint: 'Choose the beneficiary Itaú account to register payment notifications.',
    webhookRegistered: 'Notifications registered. You can register again for the selected account.',
    bankAccount: 'Beneficiary account',
    selectBankAccount: 'Select an Itaú account',
    itauAccountOnly: 'Select an Itaú account belonging to this entity.',
    registerWebhook: 'Register notifications',
    registering: 'Registering…',
    saveFirst: 'Save credentials before registering notifications.',
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    saved: 'Itaú boleto configuration saved',
    saveError: 'Could not save. Check the credentials and certificate, then try again.',
    webhookSaved: 'Notifications registered',
    webhookError:
      'Could not register notifications. Check the account and public integration configuration, then try again.',
  },
  avenia: {
    cardTitle: 'Avenia connection',
    cardDescription:
      "Connect the Avenia main account to import each token's statement into the bank account you choose.",
    loading: 'Loading Avenia connection',
    loadError: 'Could not load the Avenia connection. Try again.',
    emptyReadOnly: 'No Avenia account connected. Ask an administrator to connect it.',
    step1Title: '1. Generate the signing key',
    step1Hint:
      'Alchemy generates a key pair and keeps the private key. Copy the public key and register it at Avenia when you create the main account API key.',
    generateKey: 'Generate key',
    publicKey: 'Public key',
    copyKey: 'Copy public key',
    keyCopied: 'Public key copied',
    newKey: 'Generate new key',
    step2Title: '2. Enter the Avenia key ID',
    step2Hint:
      'After you register the public key, Avenia shows the key ID. Paste it here. The connection is checked before it is saved.',
    keyId: 'Key ID',
    historyLabel: 'Import history from',
    historyKept: 'Since {{date}}, the same period as the first connection',
    historyMonths_one: 'Last month',
    historyMonths_other: 'Last {{count}} months',
    connect: 'Check and connect',
    connecting: 'Checking connection…',
    connected: 'Avenia account connected',
    keyHint: 'Key ID ••••{{hint}}',
    lastSynced: 'Last sync: {{date}}',
    neverSynced: 'Not synced yet',
    historySince: 'History since {{date}}',
    syncNow: 'Sync now',
    syncQueued: 'Sync started',
    disconnect: 'Disconnect',
    disconnectTitle: 'Disconnect Avenia?',
    disconnectHint:
      'The signing key is deleted and importing stops. Imported transactions and token mappings are kept.',
    disconnected: 'Avenia disconnected',
    disconnectError: 'Could not disconnect. Try again.',
    positions: 'Account tokens',
    positionsHint:
      "Choose the company and bank account for each token. The account must be in the token's currency (USDC in USD, BRLA in BRL).",
    noPositions: 'No tokens yet',
    noPositionsHint: 'Tokens appear after the first sync, in a few moments.',
    token: 'Token',
    entity: 'Company',
    entityLabel: 'Company for token {{token}}',
    bankAccount: 'Bank account',
    bankAccountLabel: 'Bank account for token {{token}}',
    bankAccountPlaceholder: 'Select the account',
    pickEntityFirst: 'Choose the company first',
    status: 'Status',
    importing: 'Importing',
    unmapped: 'No account linked',
    mapped: 'Linked',
    reconnect: 'Reconnect with a new key',
    saveMapping: 'Save',
    saveMappingLabel: 'Save mapping for token {{token}}',
    mappingSaved: 'Mapping saved. Importing starts in a few moments.',
    createBankAccount: 'Create Avenia {{token}} account',
    bankAccountCreated:
      'Avenia {{token}} account created and mapped. Importing starts in a few moments.',
    connectionStatus: {
      ACTIVE: 'Connected',
      INACTIVE: 'Inactive',
      ERROR: 'Connection failed',
    },
    block: {
      generic: 'Import blocked',
      BALANCE_CHAIN_BROKEN: 'Blocked: statement balance does not add up',
      SOURCE_CHANGED: 'Blocked: transaction changed at Avenia',
      AMBIGUOUS_ORDER: 'Blocked: transaction order unclear',
      MAPPING_REQUIRED: 'Waiting for a linked account',
      AVENIA_TOKEN_UNSUPPORTED: 'Token not supported yet',
      DIRECTION_UNVERIFIED: 'Blocked: inflow or outflow not confirmed',
      SOURCE_POLICY_BLOCKED: "Blocked by the account's import policy",
      WRITER_REJECTED: 'Blocked: transaction refused on import',
      MAPPING_INVALID: 'Blocked: the linked bank account is no longer available; link another one',
      INVALID_TIMESTAMP: 'Blocked: invalid transaction date',
      INVALID_NATIVE_AMOUNT: 'Blocked: invalid transaction amount',
    },
    blockEvidence: 'Avenia transaction {{logId}}',
    missingOpRead: 'To link bank accounts you also need the op:read and org:read permissions.',
    errors: {
      generic: 'Could not finish. Try again in a few minutes.',
      KEY_DRAFT_NOT_FOUND: 'The generated key was not found. Generate a new key.',
      KEY_DRAFT_CHANGED: 'A newer key was generated. Use the public key shown now.',
      AVENIA_VALIDATION_FAILED:
        'Avenia did not accept the connection. Check that this is the registered public key and that the key ID is right.',
      ACCOUNT_IDENTITY_CHANGED:
        'This key ID belongs to another Avenia account. Disconnect before connecting a different account.',
      CONNECTION_CHANGED: 'The connection changed while you were editing. Reload the page.',
      AVENIA_TOKEN_UNSUPPORTED: 'This token is not supported yet.',
      CURRENCY_MISMATCH: "The bank account must be in the token's currency.",
      MISSING_ACCOUNT_CURRENCY_EVIDENCE:
        "Confirm the bank account's currency in its settings before linking it.",
      MAPPING_HAS_IMPORTS:
        'This token already has transactions imported into this account and cannot move to another account.',
      BANK_ALREADY_MAPPED: 'This bank account is already linked to another token.',
      AVENIA_TOKEN_BLOCKED:
        "A token's import was blocked for review. See its status in the token list.",
      AUTH_FAILED:
        'Avenia refused the key. Reconnect with a new key and check its registration at Avenia.',
      SYNC_FAILED: 'The last sync failed. It is retried automatically.',
      PAGINATION_INCOMPLETE:
        'Avenia did not return the full statement. The sync is retried automatically.',
    },
  },
  brex: {
    cardTitle: 'Brex connection',
    cardDescription: 'One key per Brex account; map its legal entities to Alchemy companies.',
    connectAccount: 'Connect Brex account',
    connectTitle: 'Connect Brex account',
    empty: 'No Brex account connected. Connect the Brex account key.',
    emptyReadOnly: 'No Brex account connected. Ask an administrator to connect it.',
    title: 'Brex',
    alchemyEntity: 'Alchemy company',
    token: 'Access key',
    tokenHint:
      'Paste the Brex account key with legal_entities.readonly permission. It will be verified before saving.',
    tokenRequired: 'Enter the Brex access key.',
    tokenTooLong:
      'The key must have no more than 500 characters. Check the key in the Brex dashboard.',
    connect: 'Test and connect',
    saving: 'Verifying connection…',
    saved: 'Brex connection saved',
    loading: 'Loading Brex connection',
    loadError: 'Could not load connections. Try again.',
    authError:
      'Brex did not accept the key. Check the key and its permissions in the Brex dashboard.',
    invalidToken: 'The key could not be used. Copy the key again from the Brex dashboard.',
    unavailable: 'Could not reach Brex. Try again in a few minutes.',
    saveError: 'Could not save the connection. Try again in a few minutes.',
    noCompanies: 'No companies available',
    noCompaniesHint: 'Create an Alchemy company to map it to a Brex company.',
    lastValidated: 'Last verified: {{date}}',
    readOnly:
      'To change the connection, contact an administrator with permission to manage integrations.',
    missingScope:
      'The key needs legal_entities.readonly permission. Update its permissions in the Brex dashboard.',
    alreadyMapped:
      'This Alchemy company is already mapped to another Brex company. Remove the previous mapping first.',
    notFound: 'The company is no longer available. Reload the page and check the mapping.',
    mappings: 'Company mappings',
    mappingHint:
      'Map each Brex company to its Alchemy company. Each mapping is saved separately. Accounts, cards and transactions only reach Alchemy once the company is mapped.',
    brexEntity: 'Brex company',
    mappingLabel: 'Alchemy company for {{name}}',
    unmapped: 'Do not map',
    refresh: 'Refresh Brex companies',
    refreshed: 'Brex companies refreshed',
    mappingSaved: 'Mapping saved',
    saveMapping: 'Save',
    saveMappingLabel: 'Save mapping for {{name}}',
    noLegalEntities: 'No Brex companies found',
    noLegalEntitiesHint: 'Check the account companies in the Brex dashboard and refresh the list.',
    entitiesError: 'Could not load Alchemy companies. Try again.',
    discardTitle: 'Discard changes?',
    discardHint: 'The unsaved key and mappings will be discarded.',
    discard: 'Discard and leave',
    keepEditing: 'Keep editing',
    syncInitial:
      'Initial sync since {{date}} in progress — it can take a few minutes. You can leave this page.',
    syncInitialDefault:
      'Initial sync of the last 12 months in progress — it can take a few minutes. You can leave this page.',
    historyLabel: 'Import history from',
    historyMonths_one: '{{count}} month ago',
    historyMonths_other: '{{count}} months ago',
    historyHint: 'Applies to the first sync only; afterwards it fetches only what is new.',
    historySince: 'History since {{date}}',
    syncQueued: 'Queued: waiting for the sync in progress to finish.',
    syncQueuedShort: 'Queued: waiting for its turn to sync.',
    syncFetching: 'Fetching what is new…',
    syncNow: 'Sync now',
    syncing: 'Syncing…',
    syncDone: 'Brex sync finished',
    syncFailed: 'The Brex sync failed. Try again in a few minutes.',
    syncAlreadyRunning: 'A sync is already running.',
    lastSynced: 'Last synced: {{date}}',
    neverSynced: 'Not synced yet',
    keyHint: 'Key ••••{{hint}}',
    payments: {
      label: 'Payments',
      enabled: 'Enabled',
      missingScope:
        'The token has no payments permission — generate a token with the transfers and vendors scopes and paste it here',
      unknown: 'Could not check',
    },
    replaceKey: 'Replace key',
    replaceTitle: 'Replace the Brex key',
    replaceHint:
      'Paste the new key. It is verified before replacing the current one; if verification fails, the current connection is kept.',
    replaceConfirm: 'Test and replace',
    replaced: 'Key replaced',
    disconnect: 'Disconnect',
    disconnectTitle: 'Disconnect Brex?',
    disconnectHint:
      'The key will be deleted and Alchemy will stop accessing Brex. Company mappings are kept and apply again when you reconnect.',
    disconnected: 'Brex disconnected',
    disconnectError: 'Could not disconnect. Try again.',
    status: {
      ACTIVE: 'Connected',
      INACTIVE: 'Inactive',
      ERROR: 'Connection failed',
      UNCONFIGURED: 'Not connected',
    },
  },
  common: {
    empty: '—',
    actions: {
      cancel: 'Cancel',
    },
  },
  setupCard: {
    title: 'Configure {{name}}',
    description: {
      focusNfe: 'Activate the integration to enable entity setup (A1 certificate).',
      tecnospeed:
        'Enable the integration to send AP payments via the Tecnospeed VAN. Software House credentials live on the API server; here you activate the tenant and pick a reference environment.',
      openFinance:
        'Connect bank accounts and cards via Open Finance Brasil. No credentials to configure.',
      default: 'Complete the credentials below to activate the integration',
    },
    requiredFields: 'Required fields',
    footerHint: 'You can adjust these settings later',
    connecting: 'Connecting...',
    connect: 'Connect {{name}}',
    toasts: {
      configError: 'Failed to configure the integration. Check your credentials.',
    },
    kamino: {
      formAria: 'Kamino credentials',
      pasteShow: 'Paste credentials (text format)',
      pasteHide: 'Hide paste area',
      pastePlaceholder:
        'Paste the credentials here in the format:\nApp: xxx\nCN: xxx\nIDUsr: xxx\nUsr: xxx\nHash: xxx',
      pasteHelper: 'Paste the credentials block and fields will be filled automatically.',
      fields: {
        app: {
          label: 'App (Application Token)',
          placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
          helper: 'Application token provided by Kamino',
        },
        companyGuid: {
          label: 'C (Company GUID) - Optional',
          placeholder: 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX',
          helper: 'Company GUID (required for the generic api.kamino.tech API)',
        },
        companyIdentifier: {
          label: 'CN (Company Identifier)',
          placeholder: 'CompanyName123',
          helper: 'Company identifier in Kamino',
        },
        userId: {
          label: 'IDUsr (User ID)',
          placeholder: '123',
          helper: 'User ID in Kamino',
        },
        userToken: {
          label: 'Usr (User Token)',
          placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
          helper: 'User token in Kamino',
        },
        hash: {
          label: 'Hash (Validation Hash)',
          placeholder: 'Base64 encoded hash...',
          helper: 'Validation hash provided by Kamino',
        },
      },
    },
    openFinance: {
      connectAccounts: 'Connect accounts',
    },
    focusNfe: {
      formAria: 'Focus NFe activation',
      masterTokenNote:
        'The Focus NFe master token is managed by the system (no Focus account required).',
      footerHint: 'You can configure each entity after activation',
      activating: 'Activating...',
      activate: 'Activate {{name}}',
    },
    tecnospeed: {
      formAria: 'Tecnospeed Pagamentos activation',
      platformNote:
        'Do not paste keys here: communication with Tecnospeed (Pagamento Bancário / SH) uses Alchemy-wide platform credentials on the server.',
      bullet1:
        'Activating this integration is the commercial opt-in: it confirms the tenant may use the Tecnospeed flow enabled by Alchemy.',
      bullet2:
        'Per bank account, register the VAN agreement and any bank-required authorization (letter / bank workflow).',
      bullet3:
        'Use Pagamento Bancário documentation for timelines and letter formats per institution.',
      bullet4:
        'On activation, the ERP attempts to register the payer (cedente) at Tecnospeed for each entity with a 14-digit CNPJ.',
      environmentLabel: 'Environment stored on the tenant',
      staging: 'Staging',
      production: 'Production',
      helper:
        'Software House credentials (CNPJ + token) are set via API env vars (`TECNOSPEED_CNPJ_SH`, `TECNOSPEED_TOKEN_SH`). Runtime API environment follows `TECNOSPEED_ENVIRONMENT` on the server; the value below is saved on the tenant record for reference.',
      footerHint: 'After activating, open Bank accounts to finish setup per bank.',
      activating: 'Activating...',
      activate: 'Activate {{name}}',
    },
    itau: {
      environmentLabel: 'Itaú environment',
      environmentHelper:
        'Use sandbox until flows are validated; switch to production only with production credentials and contract. With ERP default hosts, sandbox and production both use api.itau.com.br — Itaú typically separates environments via credentials/contract, not hostname.',
      validation: {
        invalidCertificatePem:
          'Invalid certificate PEM. Paste the full block with BEGIN/END CERTIFICATE.',
        invalidPrivateKeyPem:
          'Invalid private key PEM. Paste the full block with BEGIN PRIVATE KEY (or equivalent).',
      },
      pemDrop: {
        certificateHint: 'Drag and drop a .crt / .pem file or choose a file.',
        privateKeyHint: 'Drag and drop a .key / .pem file or choose a file.',
        chooseFile: 'Choose file',
        chooseCertificateFile: 'Choose certificate file',
        choosePrivateKeyFile: 'Choose private key file',
        readFailed: 'Could not read one or more files. Try another file or paste the PEM text.',
        noMatchingFileCertificate:
          'No certificate PEM found. Drop a .crt/.pem file that contains BEGIN CERTIFICATE.',
        noMatchingFilePrivateKey:
          'No private key PEM found. Drop a .key/.pem file that contains BEGIN PRIVATE KEY.',
      },
    },
    generic: {
      placeholders: {
        select: 'Select...',
        apiKey: 'sk_live_...',
        secret: '••••••••',
      },
      environment: {
        production: 'Production',
        sandbox: 'Sandbox',
      },
      entities: {
        main: 'Main company',
        branchSp: 'Sao Paulo branch',
        branchRio: 'Rio de Janeiro branch',
      },
    },
    optionalFields: 'Optional settings',
    optionalFieldsPlaceholder: 'Leave blank to configure later',
    help: {
      title: 'Need help?',
      descriptionPrefix: 'Check the',
      documentation: '{{name}} documentation',
      descriptionSuffix: 'to obtain your credentials.',
    },
  },
  pluggyConnect: {
    title: 'Connect Open Finance accounts',
    description:
      'Select the entity and connect your bank accounts and credit cards through Open Finance Brasil.',
    entityLabel: 'Entity',
    entityPlaceholder: 'Select entity',
    entityHelper: 'The connection will be linked to this entity for reconciliation.',
    selectEntity: 'Please select an entity',
    tokenError: 'Failed to get token. Check if Open Finance is configured.',
    success: 'Accounts connected successfully!',
    successConservative: 'Authorization complete. Accounts will be linked shortly.',
    error: 'Error connecting. Please try again.',
    closedWithoutSuccess:
      'Connection not completed. Authorization was cancelled or did not finish. You can try again.',
    closedWithoutSuccessNamed:
      'Connection with {{institution}} not completed. Try again or choose another institution.',
    loading: 'Generating link...',
    continue: 'Continue',
  },
  plaidConnect: {
    title: 'Connect a US bank',
    description:
      'Pick the entity that owns the accounts and sign in to the bank in the Plaid window. Read only: balances, transactions and holdings.',
    entityLabel: 'Entity',
    entityPlaceholder: 'Select an entity',
    connect: 'Connect bank',
    connecting: 'Connecting…',
    tokenError: 'Could not start the Plaid connection. Please try again.',
    success: 'Institution connected',
    syncPending:
      'Institution connected. Plaid is still preparing the data; synchronization will continue shortly.',
    exchangeError: 'Could not finish connecting the institution.',
    refreshError: 'The bank is connected, but the page did not update. Reload the page.',
    historyLabel: 'Import history from',
    historyMonths_one: '{{count}} month ago',
    historyMonths_other: '{{count}} months ago',
    historyHint: 'Applies to the first sync only; afterwards it fetches only what is new.',
    alreadyConnected:
      'This institution is already connected for this entity. Use Reconnect on the existing connection; for another account at the same bank, contact support.',
    existingConnections:
      'This entity already has: {{institutions}}. For a bank that is already connected, use Reconnect in the connections list.',
  },
  plaidConnections: {
    title: 'Accounts connected through Plaid',
    description:
      'Each institution is associated with an entity. Imported accounts become available for cash flow and reconciliation.',
    loadError: 'Could not load Plaid connections.',
    missingOpRead: 'You need op:read permission to view connected Plaid accounts.',
    retry: 'Retry',
    connectAnother: 'Connect another institution',
    connectFirst: 'Connect an institution',
    empty: 'No active Plaid connections.',
    unknownInstitution: 'Plaid institution',
    unknownEntity: 'Entity not found',
    missingEntity: 'Entity not assigned',
    entity: 'Entity: {{entity}}',
    lastSync: 'Last synchronized: {{date}}',
    neverSynced: 'Not synchronized yet',
    transactionsSynced: 'Transactions synchronized',
    awaitingFirstSync: 'Waiting for transactions',
    noAccountsYet: 'The institution is still making the accounts available.',
    syncNow: 'Sync now',
    syncing: 'Synchronizing...',
    syncPending: 'The institution is still processing this connection. Try again shortly.',
    syncProviderError: 'Plaid returned error {{code}}. The connection may need attention.',
    syncSuccess:
      'Sync complete: {{bank}} bank transactions, {{card}} card transactions, and {{investments}} investments imported.',
    syncError: 'This Plaid connection could not be synchronized.',
    disconnect: 'Disconnect',
    disconnectTitle: 'Disconnect institution?',
    disconnectDescription:
      "Plaid's access to {{institution}} will be revoked and future synchronization will stop. Accounts, transactions, and reconciliations already imported will remain in the ERP.",
    confirmDisconnect: 'Disconnect institution',
    disconnecting: 'Disconnecting...',
    disconnectSuccess: 'Institution disconnected from Plaid.',
    disconnectError: 'This institution could not be disconnected.',
    reconnect: 'Reconnect',
    reconnectNeeded:
      'The institution asked for a new sign-in. Reconnect to resume synchronization without creating a new connection.',
    reconnectError: 'Could not start reconnecting with Plaid.',
    importedFrom:
      'This bank already had transactions in the system; we imported from {{date}} on to avoid duplicates.',
    awaitingLink:
      'Accounts waiting to be linked by hand: {{count}}. The source that fed them is gone; contact support to link them without duplicating history.',
    heldPreLink:
      'Transactions from before the connection held for review: {{count}}. They may already be in the system; contact support to review them.',
    cancel: 'Cancel',
    status: {
      ACTIVE: 'Active',
      PENDING_AUTH: 'Processing',
      ERROR: 'Needs attention',
      SUSPENDED: 'Suspended',
      INACTIVE: 'Inactive',
    },
  },
  pluggyStatusBanner: {
    title_one: 'Bank connector instability (Pluggy)',
    title_other: 'Instability on {{count}} bank connectors (Pluggy)',
    description:
      'The Open Finance integration (Pluggy) reports unavailable or unstable connectors. Sync and reconciliation may be affected until service is restored.',
    connectors: 'Affected connectors: {{labels}}.',
    statusPageLink: 'View Pluggy status',
    dismiss: 'Dismiss notice',
  },
  connectedAccounts: {
    title: 'Connected accounts',
    description: 'Bank accounts and cards linked via Open Finance Brasil.',
    empty:
      'No accounts connected. Click "Connect accounts" to link bank accounts and cards via Open Finance Brasil.',
    emptyShort: 'No accounts connected.',
    institution: 'Institution',
    status: 'Status',
    lastSync: 'Last sync',
    unlink: 'Unlink',
    cancelPending: 'Cancel',
    deletePending: 'Delete',
    cancelPendingSuccess: 'Pending connection removed.',
    cancelPendingError: 'Failed to remove connection. Please try again.',
    pendingConnectionLabel: 'Pending connection',
    pendingConnectionDescription:
      'Authorization was not completed. Try again or cancel this connection.',
    unlinkComingSoon: 'Unlink — Coming soon',
    unlinkComingSoonTooltip: 'Full unlink (LGPD, provider revocation) will be available soon.',
    unlinkSuccess: 'Account unlinked successfully.',
    unlinkError: 'Failed to unlink account. Please try again.',
    connectButton: 'Connect accounts',
    glPending: 'GL pending',
    glPendingPerAccountTooltip: 'Accounting account not linked. Click to edit and link.',
    glPendingAlert:
      'Some accounts do not have a linked accounting account. Configure them now before reconciling transactions.',
    ownerDocumentMismatchTitle: 'Account ownership mismatch',
    ownerDocumentMismatchDescription:
      'The bank-reported owner for {{count}} account(s) does not match the selected entity CNPJ. Review this connection before using this data.',
    ownerDocumentMismatchBlockedDescription:
      'This connection was suspended because the bank-reported owner for {{count}} account(s) does not match the selected entity CNPJ.',
    glConfig: {
      open: 'Configure GL accounts',
      title: 'Configure GL accounts',
      description:
        'Confirm an existing GL account or create a new one for each pending Open Finance account.',
      empty: 'All connected accounts already have a linked GL account.',
      bankLabel: 'Bank account',
      cardLabel: 'Card',
      cardInstitutionGroupLabel: 'Cards from the same issuer',
      cardGroupLabel: '{{institutionName}} ({{cardCount}} cards)',
      suggestion: 'Preselected suggestion',
      selectPlaceholder: 'Select the GL account',
      create: 'Create new',
      link: 'Link',
      linkSuccess: 'GL account linked successfully.',
      linkError: 'Could not link the GL account.',
      createSuccess: 'GL account created and linked successfully.',
      createError: 'Could not create the GL account.',
      loadError: 'Could not load the data needed to configure GL accounts.',
      retry: 'Retry',
      confirmBulkTitle: 'Apply to all cards from this issuer?',
      confirmBulkDescription:
        '{{institutionName}} has {{cardCount}} pending card(s). The GL account {{glAccountName}} will be linked to all of them.',
      confirmBulkConfirm: 'Link {{cardCount}} card(s)',
      confirmBulkCancel: 'Cancel',
    },
    entityLabel: 'Entity',
    resumeAuth: 'Continue authorization',
    resumeAuthDescription:
      'Complete the authorization in your bank app to activate this connection.',
    reconnect: 'Reconnect',
    reconnectDescription: 'Re-open the widget to add accounts or refresh consent.',
    tryResync: 'Try re-sync',
    tryResyncDescription:
      'Attempts to re-sync using stored credentials. If it fails, use Reconnect.',
    tryResyncSuccess: 'Re-sync started. Wait a few seconds.',
    tryResyncRequiresReconnect: 'Invalid or expired credentials. Use Reconnect to authorize again.',
    syncTransactions: 'Sync',
    syncTransactionsTitle: 'Fetch transactions for bank and card accounts in this connection',
    syncInvestments: 'Sync investments',
    syncInvestmentsTitle: 'Fetch investment positions (CDB, funds, stocks) for this connection',
    syncInvestmentsSuccess:
      'Investments synced: {{positionsProcessed}} position(s), {{transactionsCreated}} transaction(s).',
    syncInvestmentsError: 'Failed to sync investments. Please try again.',
    syncLoans: 'Sync loans',
    syncLoansTitle: 'Fetch credit contracts for this connection',
    syncLoansSuccess: 'Loans synced: {{positionsProcessed}} contract(s).',
    syncLoansError: 'Failed to sync loans. Please try again.',
    syncSuccess: 'Sync enqueued. {{accountsSynced}} account(s), {{totalRecords}} transaction(s).',
    syncError: 'Failed to sync transactions. Please try again.',
    reprocess: 'Reprocess',
    reprocessTitle: 'Re-run bank/card account sync for this connection',
    reprocessSuccess: 'Reprocess enqueued. Job: {{jobId}}',
    reprocessError: 'Failed to reprocess connection. Please try again.',
    backfillAccountData: 'Update account data',
    backfillAccountDataTitle: 'Fix account data from metadata',
    backfillDialogTitle: 'How would you like to update?',
    backfillDialogDescription: 'Choose the type of update:',
    backfillOptionAccountDataOnly: 'Account identification only (branch, account, bank)',
    backfillOptionAccountDataOnlyDesc:
      'Updates only account data from metadata. Does not sync transactions.',
    backfillOptionFull: 'Full reprocess (includes transactions)',
    backfillOptionFullDesc: 'Re-runs account sync and fetches transactions.',
    backfillSuccessAccountData: '{{count}} account(s) updated.',
    backfillSuccessFull: 'Full reprocess enqueued.',
    backfillError: 'Failed to update. Please try again.',
    reprocessDialogTitle: 'Confirm reprocess',
    reprocessDialogDescription:
      'The bank accounts and cards sync for this connection will be re-run. This may recreate missing accounts or update existing data. Continue?',
    unlinkDialogTitle: 'Confirm unlink',
    unlinkDialogDescription:
      'The connection will be deactivated and no longer appear in the list. Linked bank accounts and cards will remain in the system but will no longer receive automatic sync. Continue?',
    reactivate: 'Reactivate',
    statusLabels: {
      PENDING_AUTH: 'Pending authorization',
      ACTIVE: 'Active',
      INACTIVE: 'Inactive',
      ERROR: 'Error',
      SUSPENDED: 'Suspended',
    },
    connectedAt: 'Connected on {{date}}',
    dueDay: 'Due day {{day}}',
    openFinanceSyncInfoTitle: 'Open Finance data — how it updates',
    openFinanceSyncInfoIconTooltip:
      'Open for a short, plain explanation of how movements and balance arrive. If your balance and statement do not match, we tell you what to do next.',
    openFinanceSyncInfoBullet1:
      'New transactions or connection changes are notified to the system, typically near real time.',
    openFinanceSyncInfoBullet2: 'Scheduled automatic syncs backfill delayed or missing data.',
    openFinanceSyncInfoBullet3:
      'To refresh on demand, use “Sync” on the connection (Integrations).',
    openFinanceSyncInfoBullet3BankStatement:
      'To refresh manually, use “Sync pending” on the Statement tab (syncs transactions and recalculates daily balances for the period).',
    openFinanceSyncInfoBullet4:
      'Account balance and the transaction list may update at different times; the statement usually converges shortly after.',
    openFinanceSyncInfoFootCardStatement:
      'When you return to this tab, the bills and activity list refresh.',
  },
  featuresPreview: {
    title: 'What you get',
    emptyFeatures: 'No features listed',
    syncedDataTitle: 'Synced data',
    moreModules: '+ {{count}} more modules',
    emptyModules: 'No data modules available',
    focusNfeExtraFeatures: {
      issueNfe: 'NF-e issuance',
      issueNfse: 'NFS-e issuance',
      nfeManifestation: 'NF-e manifestation',
    },
  },
  pipefyConfiguration: {
    title: 'Pipefy configuration',
    description:
      'Configure one connection and pipe for all tenant entities or one specific entity.',
    scope: {
      title: 'Scope',
      description: 'An entity configuration overrides the tenant-wide configuration.',
      label: 'Apply configuration to',
      tenant: 'All tenant entities',
      usingTenantFallback: 'Using the tenant-wide configuration as fallback.',
      usingEntityOverride: 'Using an entity-specific configuration.',
    },
    execution: {
      title: 'Integration execution',
      description: 'When enabled, Pipefy can create bills and execute business rules.',
      label: 'Enable integration execution',
      hint: 'When enabled, new cards may create bills; Pipefy may also approve, cancel, and move cards.',
      incomplete: 'Complete the business rules before enabling this option.',
      confirmTitle: 'Enable integration execution?',
      confirmDescription:
        'After activation, new cards may create bills and events may approve, cancel, and move Pipefy cards.',
      confirmCancel: 'Cancel',
      confirmAction: 'Enable execution',
    },
    connection: {
      title: 'Connection',
      description: 'Use a Pipefy Service Account token. The stored token is never shown again.',
      token: 'Access token',
      tokenPlaceholder: 'Paste the Pipefy token',
      tokenConfigured: 'Token configured — enter another only to replace it',
      success: 'Connection validated',
    },
    webhooks: {
      title: 'Active webhooks',
      description: 'URLs currently configured to receive events from Pipefy.',
      tenantScope: 'All tenant entities',
      providerId: 'Pipefy ID: {{id}}',
      notProvisioned: 'not provisioned',
      loading: 'Loading active webhooks',
      empty: 'No active webhook configured.',
      pendingUrl: 'URL that will be configured on activation',
    },
    pipe: {
      title: 'Pipe',
      description: 'Discover accessible pipes and select exactly one.',
      label: 'Selected pipe',
      placeholder: 'Select a pipe',
      identifierFormat: 'id: {{id}}, suid: {{suid}}',
    },
    mapping: {
      title: 'Mappings',
      description: 'Map required fields and define the action for each phase.',
      selectField: 'Select a field',
      ignore: 'Ignore',
      process: 'Available for later processing',
      noAttachmentField: 'No field — keep the current flow',
      noBillLinkField: 'No field — do not write a link',
      attachmentFieldsGroup: 'Attachment fields',
      otherFieldsGroup: 'Other fields',
      billLinkHint:
        'Optional. First create a dedicated short or long text field in Pipefy, then select it here. When the card is linked to an active bill, the ERP fills it with the direct bill link.',
      backfillHint: 'Queue updates for cards already correlated with active bills.',
      attachmentsHint:
        'Select one or more attachment fields. If none is selected, all attachment fields on the card are used. The bill may be created without an attachment and receive documents later.',
      customFieldsTitle: 'Additional fields for rules',
      customFieldsDescription:
        'Create aliases for card fields used as intake-rule sources. They appear as custom_<alias>.',
      addCustomField: 'Add field',
      customFieldKey: 'Rule field name',
      customFieldKeyPlaceholder: 'Example: customer_tax_id or region',
      customFieldSource: 'Pipefy source field',
      removeCustomField: 'Remove additional field',
      noDepartmentField: 'No field — do not read the department',
      noCategoryField: 'No field — do not read the category',
      departmentHint:
        "Optional. The card's department is linked to the ERP department with the same name.",
      categoryHint:
        "Optional. Select one field or, when the pipe has one category list per department, all of them: the list whose name ends with the card's department is used. The category code is available to intake rules.",
      fields: {
        taxId: 'Tax ID',
        amount: 'Amount',
        dueDate: 'Due date',
        vendor: 'Vendor',
        integratedErp: 'Integrated in ERP',
        attachments: 'Attachments (optional)',
        billLink: 'ERP bill link (optional)',
        department: 'Department (optional)',
        category: 'Category (optional)',
      },
    },
    businessRules: {
      title: 'Business rules',
      description: 'Map each ERP status to a real phase in the selected pipe.',
      approvalTriggerPhase: 'Trigger approval · PENDING_APPROVAL (bill)',
      paymentDayPhase: 'Payments of the day · scheduled-date correction',
      inProgressPhase: 'Payment in progress · PROCESSING (payment)',
      paymentCompletedPhase: 'Payment completed · PAID (payment)',
      analysisPhase: 'Analysis · SUBMITTED (bill)',
      cancelledPhase: 'Cancellation · VOID (bill)',
      selectPhase: 'Select a phase',
      optional: 'Not configured (optional)',
      requiredHint: 'The first five phases are required and must be different.',
    },
    events: {
      title: 'Events',
      description: 'Select events sent to the authenticated ERP inbox.',
      fieldUpdate: 'Field update',
      create: 'Card creation',
      move: 'Card movement',
      delete: 'Card deletion',
      cardMoveRequired: 'The card movement event is required to activate the integration.',
      intakeRequired:
        'The webhook payable intake is enabled and requires these events: {{events}}.',
    },
    actions: {
      save: 'Save',
      test: 'Test connection',
      discover: 'Discover metadata',
      activate: 'Activate',
      deactivate: 'Deactivate',
      backfillBillLinks: 'Fill existing links',
      retry: 'Retry',
    },
    statusLabels: {
      CONFIGURING: 'Configuring',
      ACTIVE: 'Active',
      INACTIVE: 'Inactive',
      ERROR: 'Error',
    },
    footer: { status: 'Status: {{status}}', draft: 'Draft not activated' },
    toasts: {
      saved: 'Configuration saved.',
      connectionSuccess: 'Pipefy connection validated.',
      discoverySuccess: 'Pipefy metadata updated.',
      activated: 'Pipefy configuration activated.',
      deactivated: 'Pipefy configuration deactivated.',
      billLinksBackfilled: 'Sync queued for {{queued}} links from {{scanned}} records scanned.',
    },
    errors: {
      load: 'Could not load the Pipefy configuration.',
      incomplete:
        'Complete the pipe, required fields, business rules, and enable card movement before activating.',
      generic: 'The operation could not be completed.',
      discovery: 'Saved pipes could not be loaded. Try discovering metadata again.',
    },
  },
  details: {
    genericIntegration: 'the integration',
    nav: {
      back: 'Back',
    },
    status: {
      connected: 'Connected',
      available: 'Available',
    },
    links: {
      website: 'Website',
      docs: 'Documentation',
    },
    actions: {
      syncNow: 'Sync now',
      syncing: 'Syncing...',
      disconnect: 'Disconnect',
    },
    focusNfe: {
      entityLabel: 'Entity',
      entityPlaceholder: 'Select an entity',
      syncNfe: 'NF-e',
      syncNfse: 'NFS-e',
    },
    onfly: {
      setup: {
        title: 'OnFly connections',
        description:
          'Configure one connection per entity. Each entity uses its own OnFly clientId/clientSecret pair.',
        schedule: 'Automatic sync at {{times}} ({{timezone}}).',
        addEntity: 'Add entity',
        loading: 'Loading connections…',
        empty: 'No entity connected. Add the first OnFly connection.',
        credentialsConfigured: 'Credentials configured',
        credentialsMissing: 'No credentials',
        lastSync: 'Last sync {{date}}',
        neverSynced: 'Never synced',
        configure: 'Configure',
        syncNow: 'Sync now',
        syncQueued: 'OnFly sync queued.',
        syncError: 'Failed to queue the OnFly sync.',
        autoApproveBadge: 'Auto-approve',
        createTitle: 'New OnFly connection',
        editTitle: 'Edit OnFly connection',
        dialogDescription: 'Select the entity and enter the matching OnFly account credentials.',
        entityLabel: 'Entity',
        entityPlaceholder: 'Select the entity',
        entityAlreadyConnected: 'This entity already has an OnFly connection.',
        credentialsReady: 'Credentials configured. Use the button below only to rotate them.',
        clientIdLabel: 'Client ID',
        clientSecretLabel: 'Client Secret',
        credentialsPlaceholder: 'Type to set/rotate',
        rotateCredentials: 'Rotate credentials',
        cancelRotation: 'Cancel rotation',
        defaultCostCenterLabel: 'Default cost centre',
        defaultCostCenterHint:
          'Used when an OnFly booking carries no cost centre. Without it, those bills stay pending classification.',
        defaultCostCenterPlaceholder: 'Select the cost centre',
        autoSyncLabel: 'Automatic sync',
        autoSyncHint: 'When off, only manual syncs run.',
        autoApproveLabel: 'Auto-approve',
        autoApproveHint: 'Fully classified OnFly bills post without human review.',
        autoApproveConfirmTitle: 'Waive review of these bills?',
        autoApproveConfirmDescription:
          "This entity's OnFly bills will be approved and posted with no human review. Turning it off later does not undo entries already posted.",
        autoApproveConfirmAction: 'Waive review',
        autoApproveEnabled: 'Auto-approval enabled.',
        autoApproveDisabled: 'Auto-approval disabled.',
        autoApproveError:
          'Could not change auto-approval. It needs a financial authority, and whoever configured the integration cannot waive review for it.',
        connect: 'Connect integration',
        save: 'Save configuration',
        loadError: 'Failed to load OnFly connections.',
        status: {
          ACTIVE: 'Active',
          INACTIVE: 'Inactive',
          ERROR: 'Error',
        },
        loadFailed:
          'Could not load the OnFly connections. The list below may be incomplete — retry before connecting an entity.',
        retry: 'Try again',
        selectEntityError: 'Select the entity.',
        alreadyConnectedError: 'This entity already has an OnFly connection.',
        credentialsRequiredCreate: 'Enter Client ID and Client Secret to connect the integration.',
        credentialsRequiredRotate: 'Enter Client ID and Client Secret to rotate the credentials.',
        createSuccess: 'OnFly connection created.',
        updateSuccess: 'OnFly connection updated.',
        saveError: 'Failed to save the connection. Check the credentials.',
        vendorCodeConflict:
          'A vendor already uses the ONFLY code with a different CNPJ. It was left untouched; OnFly was registered as ONFLY_TRAVEL.',
        discardTitle: 'Discard changes?',
        discardDescription:
          "The credentials you typed and this connection's settings will be lost. Credentials cannot be recovered afterwards.",
        discardConfirm: 'Discard',
        discardCancel: 'Keep editing',
      },
      accounts: {
        title: 'Accounts per travel type',
        description: 'Set the GL and managerial account used for each OnFly travel type.',
        entityLabel: 'Entity',
        entityPlaceholder: 'Select the entity',
        connectFirst: 'Connect at least one entity before mapping accounts.',
        coaVersion: 'Chart of accounts in effect: {{version}}',
        loading: 'Loading accounts…',
        glLabel: 'GL account (expense)',
        glPlaceholder: 'Select the GL account',
        managerialLabel: 'Managerial account',
        managerialPlaceholder: 'Select the managerial account',
        incomplete:
          '{{count}} travel type(s) still unmapped. OnFly bills of those types stay pending classification.',
        nothingToSave: 'Fill both accounts for at least one travel type.',
        saveSuccess: 'Travel type accounts saved.',
        saveError: 'Failed to save the travel type accounts.',
        discardTitle: 'Discard unsaved accounts?',
        discardDescription:
          'The GL and managerial accounts you picked have not been saved yet and will be lost.',
        loadError: 'Failed to load the travel type accounts.',
        travelTypeColumn: 'Travel type',
        replicateColumn: 'Replicate',
        replicateBelow: 'Copy these accounts to the travel types below',
        replicateDone_one: 'Accounts copied to {{count}} travel type below.',
        replicateDone_other: 'Accounts copied to {{count}} travel types below.',
        replicateTitle: 'Replace the accounts of the types below?',
        replicateDescription_one:
          '1 travel type below already has accounts set and will be replaced. Nothing is written until you save.',
        replicateDescription_other:
          '{{count}} travel types below already have accounts set and will be replaced. Nothing is written until you save.',
        replicateConfirm: 'Replace',
        loadFailed:
          'Could not load this entity\u2019s accounts. Do not edit or save them now: you would wipe the existing mapping. Try again.',
        retry: 'Try again',
        save: 'Save accounts',
        keys: {
          FLIGHT: 'Flight',
          HOTEL: 'Hotel',
          RENTAL_CAR: 'Car rental',
          BUS: 'Bus',
          CHANGE_FEE: 'Change fee',
        },
      },
    },
    contaSimples: {
      autoSyncTitle: 'Autosync active',
      autoSyncSchedule:
        'Categories every Monday at 03:00. Cards daily at 07:00. Transactions on business days at 08:00, 12:00, 16:00, and 20:00.',
      fullSyncSuccess:
        'Conta Simples sync completed. Categories: {{categorias}}; cards: {{cards}}; bank transactions: {{bankTransactions}}; card transactions: {{cardTransactions}}; cost centers: {{costCenters}}.',
      fullSyncWarning:
        'Conta Simples sync completed with {{errors}} error(s). Categories: {{categorias}}; cards: {{cards}}; bank transactions: {{bankTransactions}}; card transactions: {{cardTransactions}}; cost centers: {{costCenters}}.',
      fullSyncError: 'Failed to run the full Conta Simples sync.',
      setup: {
        title: 'Conta Simples connections',
        description: 'Configure one integration per entity (OAuth credentials and sync).',
        addEntity: 'Add entity',
        loading: 'Loading connections…',
        empty: 'No entities connected. Add the first Conta Simples connection.',
        credentialsConfigured: 'Credentials configured',
        credentialsMissing: 'No credentials',
        lastSync: 'Last sync {{date}}',
        configure: 'Configure',
        createTitle: 'New Conta Simples connection',
        editTitle: 'Edit Conta Simples connection',
        dialogDescription:
          'Select the entity and enter credentials for the matching Conta Simples account.',
        entityLabel: 'Entity',
        entityPlaceholder: 'Select an entity',
        entityAlreadyConnected: 'This entity already has a Conta Simples connection.',
        credentialsReady: 'Credentials configured. Use the button below only to rotate them.',
        apiKeyLabel: 'API Key',
        apiSecretLabel: 'API Secret',
        credentialsPlaceholder: 'Enter to set/rotate',
        rotateCredentials: 'Rotate credentials',
        cancelRotation: 'Cancel rotation',
        syncStartDateLabel: 'Sync start date (optional)',
        syncStartDatePlaceholder: 'Select start date',
        autoSyncLabel: 'Automatic sync',
        autoSyncHint: 'When disabled, only manual syncs will run.',
        autoCreateBillsLabel: 'Create bills from attachments',
        autoCreateBillsHint:
          'Uses card transaction attachments to automatically start the bill creation pipeline.',
        connect: 'Connect integration',
        save: 'Save configuration',
        loadError: 'Failed to load Conta Simples connections.',
        status: {
          ACTIVE: 'Active',
          INACTIVE: 'Inactive',
          ERROR: 'Error',
        },
        selectEntityError: 'Select an entity.',
        alreadyConnectedError: 'This entity already has a Conta Simples connection.',
        credentialsRequiredCreate: 'Enter API Key and API Secret to connect the integration.',
        credentialsRequiredRotate: 'Enter API Key and API Secret to rotate credentials.',
        createSuccess: 'Conta Simples connection created successfully.',
        updateSuccess: 'Conta Simples connection updated.',
        saveError: 'Failed to save connection. Check the credentials.',
      },
      dataSync: {
        entitySection: 'Entity',
        entityPlaceholder: 'Select an entity',
        loadingConnections: 'Loading…',
        noConnections: 'No connection configured',
        selectEntityError: 'Select an entity to sync.',
        loadConnectionsError: 'Failed to load Conta Simples connections.',
        periodSection: 'Transaction period',
        fromLabel: 'Start date',
        toLabel: 'End date',
        invalidPeriod: 'Start date cannot be after end date.',
        sync: 'Sync',
        syncing: 'Syncing...',
        categoriasName: 'Categories',
        categoriasDescription:
          'Import Conta Simples categories for reconciliation with managerial accounts.',
        categoriasSuccess: 'Categories synced: {{upserted}}/{{fetched}} (errors: {{errors}}).',
        cardsName: 'Corporate cards',
        cardsDescription: 'Refresh the list of cards linked to the account.',
        cardsEnqueued: 'Card sync enqueued (job {{jobId}}).',
        cardsAlreadyRunning: 'Card sync was already running.',
        bankName: 'Bank transactions',
        bankDescription: 'Import digital account movements into staging.',
        bankEnqueued: 'Bank transaction sync enqueued (job {{jobId}}).',
        bankAlreadyRunning: 'Bank transaction sync was already running.',
        cardTxName: 'Card transactions',
        cardTxDescription: 'Import corporate card purchases and postings.',
        cardTxEnqueued: 'Card transaction sync enqueued (job {{jobId}}).',
        cardTxAlreadyRunning: 'Card transaction sync was already running.',
        costCentersName: 'Cost centers',
        costCentersDescription: 'Refresh the snapshot of cost centers found in transactions.',
        costCentersSuccess: 'Cost centers detected in staging: {{count}}.',
        registrationSection: 'Registrations',
        movementsSection: 'Movements',
        dataSourcesSection: 'Data sources',
        cadastralData: 'Master data',
        movementsWithPeriod: 'Movements',
        movementsPeriodHint: '— uses period above',
        dimensionsSection: 'Dimension reconciliation',
        dimensionsDescription: 'Map Conta Simples cost centers and categories to Alchemy ERP.',
        reconcileCategories: 'Reconcile categories',
        reconcileCostCenters: 'Reconcile cost centers',
      },
    },
    notFound: {
      title: 'Integration not found',
      description: 'The requested integration does not exist or was removed.',
      backAction: 'Back to Integrations',
    },
    loadError: {
      title: 'Could not load integration',
      description: 'Check your connection or try again in a moment.',
      retry: 'Try again',
    },
    connectionInfo: {
      title: 'Integration active',
      connectedAt: 'Connected on {{date}}.',
      lastSync: 'Last sync: {{relative}}.',
    },
    stats: {
      syncedRecords: 'Synced records',
      lastSync: 'Last sync',
    },
    tabs: {
      sync: 'Data Sync',
      modules: 'Data modules',
      config: 'Settings',
      webhooks: 'Webhooks',
      activity: 'Activity',
    },
    config: {
      credentials: {
        title: {
          kamino: 'Kamino credentials',
          itau: 'Itaú credentials',
          default: 'API credentials',
        },
        description: {
          kamino: 'App, CN, IDUsr, Usr, and Hash configured for Kamino authentication.',
          itau: 'The OAuth client ID is shown below. Client secret, certificate, and private key are stored encrypted and are never displayed.',
          default: 'API key for authentication with {{name}}.',
        },
        kaminoLocked:
          'The credentials (App, CN, IDUsr, Usr, Hash) were set during initial setup. To change them, disconnect and connect again with new values.',
        itau: {
          clientIdLabel: 'Client ID (OAuth)',
          clientIdUnavailable: 'Not available. Use Replace credentials below with a full new set.',
          secretsStoredNotice:
            'Client secret, certificate, and private key are stored securely. They cannot be viewed or downloaded after you save them.',
          rotateCredentials: 'Replace credentials',
          rotateHint:
            'Provide a full set (client ID, secret, certificate PEM, private key PEM). Current secrets will be replaced.',
          saveRotated: 'Save new credentials',
          requiredFieldsAll:
            'Fill in client ID, client secret, certificate PEM, and private key PEM.',
        },
        updating: 'Updating...',
        updated: 'Credentials updated successfully.',
        updateError: 'Failed to update credentials.',
        apiKeyLabel: 'API key',
        apiKeyPlaceholder: 'sk_live_...',
        apiKeyHelper: 'Find your API key in the {{name}} dashboard.',
        webhookSecretLabel: 'Webhook Secret',
        webhookSecretPlaceholder: 'whsec_...',
        webhookSecretDefault: 'whsec_xxxxxxxxxxxxxxxxxxxxxxxx',
        webhookSecretHelper: 'Used to verify received webhooks.',
        update: 'Update credentials',
      },
      syncSettings: {
        title: 'Sync settings',
        description: 'Define how and when data is synced.',
        autoSyncLabel: 'Automatic sync',
        autoSyncHelper: 'Sync data automatically',
        frequencyLabel: 'Sync frequency',
        frequency: {
          realtime: 'Real-time (webhooks)',
          hourly: 'Hourly',
          daily: 'Daily',
          weekly: 'Weekly',
        },
        defaultEntityLabel: 'Default entity',
        entities: {
          main: 'Main company',
          branchSp: 'Sao Paulo branch',
          branchRio: 'Rio de Janeiro branch',
        },
        defaultEntityHelper: 'Entity where data will be imported.',
        save: 'Save settings',
      },
      features: {
        title: 'Available features',
        description: 'Features available in this integration.',
      },
      openFinance: {
        title: 'Automatic sync',
        description:
          'Open Finance Brasil syncs data automatically as connected banks and cards send transactions. No frequency settings are needed — data arrives in near real-time via webhooks.',
      },
      itauPayments: {
        title: 'PIX payments',
        description:
          'Outbound payments use Itaú Cash Management (SISPAG v1). You must set the tenant config JSON field `sispagPagador` (debit account: branch, account, tax id, account type, SISPAG module). API cancellation is not documented for this version — use the banking channel if you need to reverse a payment.',
        environmentTitle: 'API environment',
        environmentDescription:
          'Sandbox and production use different default hosts: sandbox OAuth and SISPAG live under `api.itau.com.br/sandbox`; production uses `sts.itau.com.br` for tokens and `api.itau.com.br/sispag/v1` for the API. Override STS Base URL and API Base URL in advanced tenant config if your homologation guide says otherwise.',
        effectiveApiBaseUrlLabel: 'API base URL in use',
        effectiveApiBaseUrlHint:
          'Effective SISPAG v1 base URL (tenant override or environment default). Legacy `https://api.itau.com.br` without a path is remapped to the SISPAG default for the selected environment.',
        environmentSelectLabel: 'Environment',
        saveEnvironment: 'Save environment',
        productionWarningTitle: 'Production',
        productionWarningDescription:
          'In production, operations may move real funds. Confirm credentials and contract with Itaú.',
      },
      tecnospeed: {
        title: 'Tecnospeed payments (VAN)',
        subtitle: 'Bank payments and webhooks',
        description:
          'After activation, register each origin account under Bank accounts (Tecnospeed action). Bulk send on the Payments page uses the worker queue.',
        platformCard: {
          title: 'Platform credentials',
          description:
            'The Tecnospeed (Pagamento Bancário) connection in the ERP uses Alchemy’s SH token on the server — there is no per-tenant API key on this screen.',
          bullet1:
            'Enabling the product on the tenant is separate from bank agreements and per-bank letters.',
          bullet2:
            'Each account under Bank accounts may require VAN registration and bank-specific documentation.',
          bullet3:
            'If the tenant is not active here, Tecnospeed calls for the tenant will fail until Alchemy enables access.',
          bullet4:
            'On activation, the ERP attempts to register the payer (cedente) at Tecnospeed for each entity with a 14-digit CNPJ; bank accounts and DDA use separate flows.',
        },
        nextSteps: {
          title: 'Next steps',
          description:
            'Create or edit bank accounts and complete Tecnospeed setup per account (when the bank supports the VAN channel).',
          cta: 'Go to Bank accounts',
        },
        letters: {
          title: 'Homologated banks (VAN channel)',
          description:
            'Institutions with homologated communication for Pagamento Bancário / Tecnospeed. Authorization letters or flows depend on the bank.',
          disclaimerTitle: 'Important',
          disclaimer:
            'The list reflects the public homologated-bank catalog; contracts, SLAs, and letter requirements are always defined by the bank and Tecnospeed.',
          bankCol: 'Code',
          nameCol: 'Institution',
          tableFoot:
            'To integrate an account, the bank code must be VAN-homologated. Accounts at banks outside this list do not use this channel.',
          guidanceLabel: 'Pagamento Bancário documentation (Tecnospeed)',
        },
        technical: {
          title: 'Webhooks (technical)',
          description:
            'URLs to configure in the Tecnospeed / Pagamento Bancário console when applicable. The host comes from VITE_API_URL (e.g. http://localhost:3030/api/v1).',
          paymentsUrl: 'Payments — POST',
          ddaUrl: 'DDA boletos — POST',
          webhookUrl: 'Unified webhook — POST',
          missingApiBase: 'Set VITE_API_URL in the web environment to show full URLs.',
          webhookHint:
            'The backend may require the x-tecnospeed-webhook-secret header (TECNOSPEED_WEBHOOK_SECRET) and/or an IP allowlist (TECNOSPEED_WEBHOOK_ALLOWED_IPS).',
        },
        tabs: {
          overview: 'Overview',
          banks: 'Banks & letters',
          dda: 'DDA',
          webhooks: 'Webhooks',
        },
        onboarding: {
          drawerTitle: 'Payment delivery setup',
          drawerDescription: 'Track adhesion letter, agreement and activation per bank account.',
          statusLabel: 'Status',
          statuses: {
            NOT_STARTED: 'Not started',
            LETTER_REQUESTED: 'Letter requested',
            LETTER_DOWNLOADED: 'Letter downloaded',
            LETTER_SENT_TO_MANAGER: 'Letter sent to manager',
            BANK_APPROVED: 'Bank approved',
            ACTIVE: 'Active',
            ERROR: 'Error',
          },
          startCta: 'Start adhesion letter',
          downloadLetterCta: 'Download letter (.docx)',
          markSentCta: 'Mark as sent to manager',
          confirmCta: 'Sync now',
          activateDdaCta: 'Activate DDA',
          unregisterDdaCta: 'Deactivate DDA for this account',
          letterMissing:
            'Template for this bank is pending. Request from ops or check Tecnospeed support.',
          letterMissingCta: 'Open Tecnospeed support',
          enabledProducts: 'Enabled products',
          manualRemittanceReady: 'Manual remittance ready',
          products: { DDA: 'DDA', PAYMENTS: 'Payments and remittances' },
          agreement: 'Agreement (convênio)',
          agreementPending: 'Agreement pending (awaiting manager)',
          agreementContractDate: 'Contract date',
          manager: 'Bank manager',
          managerName: 'Name',
          managerContact: 'Contact (email, phone, WhatsApp)',
          notes: 'Notes',
          saveCta: 'Save',
          errorTitle: 'Could not update onboarding',
          ddaRegistered: 'DDA active for this account',
          ddaInactive: 'DDA inactive',
        },
        ddaReadiness: {
          title: 'DDA readiness by account',
          description:
            'Combines Tecnospeed flags (ddaActived, VAN) with the signed adhesion letter uploaded in ERP.',
          loading: 'Loading DDA readiness…',
          loadError: 'Failed to load DDA readiness',
          syncFlags: 'Sync Tecnospeed flags',
          syncSuccess: 'Tecnospeed flags updated',
          syncPartial: '{{count}} sync error(s) — check API logs',
          syncError: 'Failed to sync Tecnospeed flags',
          vendorDda: 'DDA at Tecnospeed',
          letterSent: 'DDA letter sent',
          van: 'Payments VAN',
          yes: 'Yes',
          no: 'No',
          unknown: '—',
          level: {
            ready: 'Ready',
            letter_pending: 'Letter pending',
            vendor_pending: 'DDA off at Tecnospeed',
            not_registered: 'Account not registered',
          },
          ctaLetter: 'Upload letter in onboarding',
          ctaVendor: 'Check with Tecnospeed/bank',
          setupHintTitle: 'Setup incomplete',
          setupHintBody:
            'Enable DDA at Tecnospeed (ddaActived) and upload the signed letter per bank account. Boletos arrive only when both are OK.',
          bannerTitle: 'DDA is not ready on all accounts',
          bannerBody:
            '{{count}} account(s) pending (e.g. {{level}}). You can still fetch boletos, but reception may fail.',
          bannerCta: 'Open bank account',
          subscriptionHeading: "This company's debit lookup",
        },
        ddaInbox: {
          tabTitle: 'DDA inbox',
          tabDescription:
            'DDA boletos received via Tecnospeed. Mirrors the FocusNFe pattern: pull → save → list, never auto-create AP bills.',
          openInboxCta: 'Open DDA inbox',
          source: {
            label: 'Source',
            tecnospeed: 'TecnoSpeed',
            btg: 'BTG',
          },
          btg: {
            description:
              'Boletos the bank lists against the company. Fetch stores them. Linking uses a bill that already exists.',
            fetch: 'Fetch debits',
            emptyTitle: 'No debits',
            emptyDescription: 'Fetch debits when the company connection is active.',
            ignore: 'Ignore',
            unlink: 'Unlink',
            link: 'Link to existing bill',
            viewBill: 'View bill',
            skipped: 'Some companies were not queried.',
            noSubscriptionTitle: 'No company has opted in to the debit lookup',
            noSubscriptionDescription: 'Turn it on in the integrations page.',
            noSubscriptionCta: 'Open integrations',
            subscriptionsLoadError: 'Could not check which companies opted in to the debit lookup.',
            pageOf: 'Page {{page}} of {{pages}}',
          },
          filters: {
            title: 'Filters',
            popoverLabel: 'Filters',
            activeLabel: 'Active filters:',
            clearAll: 'Clear all',
            status: 'Inbox status',
            dueRange: 'Due date',
            dueFrom: 'Due (from)',
            dueTo: 'Due (to)',
            issuerCnpj: 'Issuer tax ID',
            refresh: 'Refresh DDA situation',
            fetchBoletos: 'Fetch boletos',
            reload: 'Reload list',
          },
          processingStatus: {
            NEW: 'New',
            LINKED_TO_BILL: 'Linked',
            BILL_CREATED: 'Bill created',
            IGNORED: 'Ignored',
            all: 'All',
          },
          commitmentKind: {
            PROPOSAL: 'Proposal',
            COLLECTION: 'Collection',
            DEPOSIT: 'Deposit',
            UNKNOWN: 'Unknown',
          },
          commitmentKindHint: {
            PROPOSAL: 'Voluntary payment — paying accepts the proposal.',
            COLLECTION: 'Registered collection obligation in DDA.',
            DEPOSIT: 'Deposit or contribution boleto.',
            UNKNOWN: 'Type not provided by the bank or local-only row.',
          },
          ddaVendorStatus: {
            REGISTERED: 'Registered',
            PAID: 'Paid',
            CANCELLED: 'Cancelled',
            PROTESTED: 'Protested',
            REJECTED: 'Rejected',
          },
          ddaVendorStatusHint:
            'Boleto lifecycle at the bank/DDA (registered, paid, cancelled…). Separate from inbox status (your ERP actions).',
          movimentHint: 'DDA movement: {{label}}',
          table: {
            issuer: 'Issuer',
            value: 'Amount',
            dueDate: 'Due date',
            commitmentKind: 'Type',
            ddaStatus: 'DDA situation',
            inboxStatus: 'Inbox status',
            actions: 'Actions',
            loading: 'Loading…',
            emptyTitle: 'No DDA boletos',
            emptyDescription:
              'When DDA is active on the bank account, new boletos will appear here.',
            linkBill: 'Link to existing bill',
            createBill: 'Create AP bill',
            viewBill: 'View AP bill',
            linkedBill: 'Linked bill',
            vendorInErp: 'ERP vendor',
            vendorRegistered: 'Registered',
            vendorNotRegistered: 'New tax ID',
            vendorRegisteredNoBill: 'No open bill',
            vendorInErpHint:
              'Vendor registered with an open AP bill on the same entity — link or create.',
            vendorInErpNoBillHint:
              'Vendor exists but there is no open AP bill on the same entity to link. Create one from this boleto.',
            unlink: 'Unlink',
            ignore: 'Ignore',
            restore: 'Restore',
          },
          unlinkDialog: {
            title: 'Unlink DDA boleto',
            description:
              'Removes the link to the AP bill. If the payment was auto-created from DDA, it will be cancelled.',
          },
          billPanel: {
            suggestionsTitle: 'Suggested DDA boletos ({{count}})',
            suggestionTitle: 'DDA boleto suggestion',
            emptyMergedTitle: 'DDA boleto found for this bill',
            emptyMergedSubtitle:
              'Review issuer and due date. Confirming creates the boleto payment and links DDA.',
            createPaymentWithDda: 'Create payment with this boleto',
            createPaymentManually: 'Create payment manually',
            attachStripTitle: 'Link DDA boleto',
            linkToPayment: 'Link to payment',
            weakMatchHint: 'Only amount matched — confirm issuer and due date before continuing.',
            openInbox: 'Open DDA inbox',
            useBoleto: 'Use this boleto',
            attached: 'DDA boleto linked',
            paymentCreated: 'DDA linked and boleto payment created',
            linkedOnly: 'Linked (no payment created — bill approved or no slot)',
            attachError: 'Failed to attach DDA boleto',
            unlink: 'Unlink',
            unlinked: 'DDA link removed',
            unlinkedWithPayment: 'Unlinked and auto payment cancelled',
            unlinkedManualKept: 'DDA unlinked (manual payment kept)',
            unlinkError: 'Failed to unlink',
            unlinkDialogBillDescription:
              'Removes the DDA link. Manually created payments are not deleted.',
          },
          pagination: {
            total: 'Total: {{count}}',
            previous: 'Previous',
            next: 'Next',
            page: 'Page {{page}} of {{total}}',
          },
          linkSheet: {
            title: 'Link to AP bill',
            description: 'Find the existing bill that matches this boleto.',
            boletoLabel: 'Selected boleto',
            hint: 'Suggestions from boleto amount, due date, and vendor.',
            searchPlaceholder: 'Not a match? Search by description or vendor…',
            suggestionsTitle: 'Likely matches',
            othersTitle: 'Other bills ({{count}})',
            matchReason: {
              amount: 'Amount',
              dueDate: 'Due date',
              vendor: 'Vendor',
            },
            noBills: 'No bills found.',
            noBillsCreateHint:
              'If the bill does not exist yet, create it from this boleto — the vendor will be provisioned if needed.',
            createBill: 'Create AP bill',
            cancel: 'Cancel',
            confirm: 'Link',
          },
          createBillModal: {
            title: 'Create bill from DDA boleto',
          },
          loadErrorTitle: 'Could not load DDA inbox',
          loadErrorForbidden:
            'You do not have permission to view DDA boletos. Ask your administrator for access.',
          loadErrorIntegrationInactive:
            'The Tecnospeed integration is not active for this organization. Configure the integration to view DDA boletos.',
          loadErrorTimeout:
            'The API timed out (server may be restarting). Reload the page; if it persists, restart pnpm dev:stack.',
          toasts: {
            ignored: 'Boleto ignored',
            linked: 'Linked to AP bill',
            linkedWithPayment: 'Linked and boleto payment created',
            linkedOnly: 'Linked (no payment — check bill status)',
            createdAndLinked: 'Bill created and boleto linked',
            createdAndLinkedWithPayment: 'Bill created, boleto linked, and payment created',
            createLinkError: 'Bill created but failed to link DDA boleto',
            fetchUpserted: '{{count}} boleto(s) imported from Tecnospeed',
            fetchNone: 'No new boletos in the queried window',
            fetchSkipped: 'DDA inactive or payer not ready — configure under integration DDA tab',
            fetchError: 'Failed to fetch boletos from Tecnospeed',
            linkWarning: {
              amount_divergence: 'Warning: bill amount differs from DDA boleto',
              due_date_divergence: 'Warning: bill due date differs from DDA boleto',
              barcode_divergence: 'Warning: barcode does not match',
            },
            unlinked: 'Link removed',
            unlinkedWithPayment: 'Unlinked and auto payment cancelled',
            ignoreError: 'Failed to ignore',
            restoreError: 'Failed to restore',
            linkError: 'Failed to link',
            unlinkError: 'Failed to unlink',
            loadError: 'Failed to load DDA inbox',
            statusSyncChanged: '{{count}} boleto(s) with updated DDA situation',
            statusSyncNone: 'Could not fetch situations from the bank',
          },
        },
        webhooks: {
          tabTitle: 'Webhook registrations',
          tabDescription:
            'Active subscriptions on the Tecnospeed dashboard. Use the button to register/refresh when changing environments.',
          refreshCta: 'Register / refresh webhooks',
          empty: 'No webhook registered yet.',
          statusActive: 'Active',
          statusDisabled: 'Disabled',
          statusError: 'Error',
          tunnelAlertTitle: 'Public tunnel required (local dev)',
          tunnelAlertBody:
            'Tecnospeed cannot POST to localhost. Expose your local API with cloudflared or ngrok and paste the public URL below (ending in /api/v1).',
          tunnelHint:
            'pnpm tunnel:prod-local-api  →  copy URL  →  restart API  →  register webhooks',
          publicBaseLabel: 'Public API URL (webhooks)',
          publicBaseHelper:
            'Browser keeps using {{browserApi}}; only webhooks use the public URL. Or set PUBLIC_API_BASE_URL on the API .env.',
          tunnelRequired: 'Enter the tunnel public URL (ending in /api/v1) before registering.',
          secretConfigured: 'TECNOSPEED_WEBHOOK_SECRET is set on this API.',
          secretNotConfigured:
            'TECNOSPEED_WEBHOOK_SECRET is not set (fine in dev; required in production).',
          unifiedHint:
            'PlugBank sends payments and DDA to one URL; the API routes by happen / payload shape.',
        },
      },
    },
    activity: {
      title: 'Activity log',
      description: 'History of syncs, webhooks, and integration events.',
      emptyTitle: 'No activity recorded',
      emptyDescription: 'Activity will appear here after the first sync',
      viewFullHistory: 'View full history',
    },
    disconnect: {
      title: 'Disconnect {{name}}?',
      description:
        'This action will remove the connection with {{name}}. Synced data will be kept, but new syncs will not run.',
      defaultIntegration: 'this integration',
    },
    relativeTime: {
      justNow: 'just now',
      minutesAgo: '{{count}} min ago',
      hoursAgo: '{{count}}h ago',
      daysAgo: '{{count}} days ago',
    },
    toasts: {
      kaminoSyncSuccess: 'Customer sync completed',
      kaminoSyncError: 'Failed to sync customers with Kamino',
      focusNfeEntityRequired: 'Select an entity to sync',
      focusNfeSyncQueued: 'Sync queued',
      focusNfeSyncQueuedWithCount_one: 'Sync queued ({{count}} job)',
      focusNfeSyncQueuedWithCount_other: 'Sync queued ({{count}} jobs)',
      focusNfeSyncError: 'Failed to queue Focus NFe sync',
      integrationConfigured: 'Integration configured successfully!',
      itauEnvironmentSaved: 'Itaú environment updated.',
      itauEnvironmentError: 'Could not update Itaú environment.',
      integrationConfigError: 'Failed to configure the integration. Check your credentials.',
      modulesSaved: 'Module settings saved',
      modulesSaveError: 'Failed to save settings',
    },
  },
  focusNfe: {
    loading: {
      entities: 'Loading entities...',
    },
    errors: {
      loadTitle: 'Failed to load',
    },
    status: {
      active: 'ACTIVE',
      error: 'ERROR',
      pending: 'PENDING',
      certificatePending: 'CERTIFICATE PENDING',
      suspended: 'SUSPENDED',
      notConfigured: 'NOT CONFIGURED',
    },
    testData: {
      title: 'Test data enabled',
      description: 'You can test sync with a preconfigured company.',
      cnpj: '(CNPJ: {{cnpj}}).',
      environment: 'Environment: {{environment}}.',
    },
    summary: {
      configured: '{{configured}}/{{total}} entities configured',
    },
    actions: {
      refresh: 'Refresh',
      testSync: 'Test sync',
      testSyncTitle: 'Queue sync using test token/CNPJ',
      syncAll: 'Sync all',
      syncAllTitle: 'Queue synchronization for all configured entities',
      updateCertificate: 'Edit settings',
      configure: 'Configure',
    },
    entity: {
      cnpj: 'CNPJ: {{cnpj}}',
      cnpjMissing: 'CNPJ not provided',
      certificate: 'Certificate',
      expiresAt: 'Expires on',
      lastSync: 'Last synchronization',
      receivedNfs: 'Received invoices',
      errorTitle: 'Error',
    },
    modules: {
      nfe: {
        label: 'NF-e',
        description: 'SEFAZ (NSU)',
      },
      nfse: {
        label: 'NFS-e',
        description: 'Municipal/legacy',
      },
      nfsen: {
        label: 'NFS-e Nacional',
        description: 'National standard',
      },
      emissaoNfe: {
        label: 'NF-e Issuance',
        description: 'Mapped to habilita_nfe',
      },
      emissaoNfce: {
        label: 'NFC-e issuance',
        description: 'Enables consumer invoice issuance.',
      },
      emissaoNfcom: {
        label: 'NFCom issuance',
        description: 'Enables communication invoice issuance.',
      },
      emissaoDce: {
        label: 'DC-e issuance',
        description: 'Enables electronic content declaration issuance.',
      },
      emissaoNfseMunicipal: {
        label: 'Municipal NFS-e issuance',
        description: 'Enables issuance through the municipal/legacy provider.',
      },
      emissaoNfse: {
        label: 'NFS-e Nacional issuance',
        description: 'Enables issuance through the national NFS-e environment.',
      },
      emissaoCte: {
        label: 'CT-e issuance',
        description: 'Enables transport document issuance.',
      },
      emissaoMdfe: {
        label: 'MDF-e issuance',
        description: 'Enables electronic manifest issuance.',
      },
      recebimentoNfe: {
        label: 'NF-e Receivables',
        description: 'Mapped to habilita_manifestacao',
      },
      recebimentoNfse: {
        label: 'NFS-e Receivables',
        description: 'Mapped to habilita_nfsen_recebidas_producao',
      },
    },
    setup: {
      title: 'Configure entity in Focus NFe',
      description: 'Confirm the entity data and, if needed, upload the A1 certificate (.pfx/.p12).',
      certificateSafety: {
        title: 'Safe certificate update',
        description:
          'Saving settings does not change the current certificate. Certificate and password are updated only when you select a new file (.pfx/.p12) and provide its password.',
      },
      productionLocked: {
        title: 'Protected emission settings',
        description:
          'Modules, series, and credentials remain preserved in Focus NFe. Only the next RPS sequence can be adjusted below.',
      },
      sequenceSettings: {
        label: 'Next RPS sequence',
        description:
          'Municipal and national NFS-e use independent sequences. For safety, a sequence can only move forward.',
        municipal: 'Next municipal RPS',
        national: 'Next national RPS',
        advance: 'Advance sequence',
        saveBlockedByPendingChange:
          'Advance the RPS sequence or undo the change before saving the other settings.',
        confirmTitle: 'Confirm RPS sequence change?',
        confirmDescription:
          'The next issuance will use the new sequence. Confirm the number has not been used by the municipality.',
        reasonLabel: 'Reason for change',
        reasonPlaceholder: 'E.g. align with the current municipality sequence',
        cancel: 'Go back',
        confirm: 'Change sequence',
      },
      sections: {
        company: 'Company data',
        modules: 'Integration modules',
        address: 'Address (optional)',
        certificate: 'Digital certificate (optional)',
      },
      fields: {
        legalName: {
          label: 'Legal name',
          placeholder: 'Legal Name Ltd',
        },
        companySource: {
          label: 'Entity registration data',
          description:
            'These fields are managed in Entity settings and automatically synced with Focus NFe.',
          action: 'Edit in Entity',
        },
        companyConfirm: {
          description: 'Confirm the company data below before continuing with setup.',
        },
        tradeName: {
          label: 'Trade name',
          placeholder: 'Trade Name',
        },
        cnpj: {
          label: 'CNPJ',
          placeholder: '11222333000181',
        },
        taxRegime: {
          label: 'Tax regime',
          description: 'Suggestion based on the entity fiscal settings.',
          placeholder: 'Select...',
          clear: 'Do not inform',
          loading: 'Loading suggested tax regime...',
        },
        stateRegistration: {
          label: 'State registration',
          optional: 'Optional',
          placeholder: '1234567890',
        },
        municipalRegistration: {
          label: 'Municipal registration',
          optional: 'Optional',
          placeholder: '12345',
        },
        modules: {
          label: 'Emission documents',
          description:
            'Configure issued fiscal documents. Series and next-number fields use Focus NFe production fields.',
        },
        receivingModules: {
          label: 'Receivables documents',
          description:
            'Configure received fiscal documents and automatic processing for accounts payable.',
        },
        emissionSettings: {
          label: 'Issuance settings',
          description:
            'Options applied to the Focus NFe production environment, including when the active endpoint is homologation.',
        },
        sendEmailToRecipient: {
          label: 'Send email to recipient',
          description: 'Sends email to the recipient/customer after issuance.',
        },
        discriminateTaxes: {
          label: 'Discriminate taxes',
          description: 'Calculates approximate taxes for NF-e and NFC-e.',
        },
        showDanfseBadge: {
          label: 'Show Focus NFe badge on DANFS-e',
          description: 'Displays the Focus badge on issued DANFS-e documents.',
        },
        emission: {
          series: 'Series',
          seriesPlaceholder: '1',
          nextNumber: 'Next number',
          nextRps: 'Next RPS',
          nextNumberPlaceholder: '1',
          synchronousDescription: 'Authorizes/rejects in the same request when supported.',
        },
        nfeSynchronous: {
          label: 'Use synchronous sending - NF-e',
        },
        mdfeSynchronous: {
          label: 'Use synchronous sending - MDF-e',
        },
        prefeituraLogin: {
          label: 'Municipality login',
          placeholder: 'Municipality login',
        },
        prefeituraPassword: {
          label: 'Municipality password',
          placeholder: 'Municipality password',
        },
        nfeRecebimentoStartDate: {
          description:
            'Start date for received NF-e import. SEFAZ only distributes the last 90 days.',
          locked:
            'Set on first enablement and fixed at Focus NFe. Changing it here does not backfill — older NF-e must be imported manually from their XML.',
          maybeKept:
            'Start date for received NF-e import, applied only if this company is new at Focus NFe. If a company already exists for this CNPJ and is receiving, it is adopted and keeps its own start date. SEFAZ only distributes the last 90 days.',
        },
        processAsApFrom: {
          description:
            'Automatically create accounts payable bills only for received NFs from this date.',
          cardLabel: 'Create accounts payable from',
          cardDescription: 'Older NFs remain imported, but do not create automatic bills.',
        },
        autoProcessReceivedNfs: {
          label: 'Auto-process NF-es and NFS-es',
          description:
            'When disabled, notes are still imported but no accounts payable bills are created automatically.',
          cardDescription:
            'Toggle without changing company, certificate, or other entity settings.',
        },
        nfseForcedEmissionMode: {
          label: 'NFSe emission mode',
          description:
            'Automatic uses municipality routing. Force Nacional or Municipal when needed.',
          cardLabel: 'NFSe emission',
          cardDescription: 'Choose whether emission uses the Nacional or Municipal (legacy) API.',
          automatic: 'Automatic',
          nacional: 'Nacional',
          municipal: 'Municipal',
        },
        addressStreet: {
          label: 'Street',
          placeholder: 'Example Street',
        },
        addressNumber: {
          label: 'Number',
          placeholder: '100',
        },
        addressDistrict: {
          label: 'District',
          placeholder: 'Downtown',
        },
        addressCity: {
          label: 'City',
          placeholder: 'Sao Paulo',
        },
        addressState: {
          label: 'State',
          placeholder: 'SP',
        },
        addressPostalCode: {
          label: 'Postal code',
          description: 'Enter CEP and click search to auto-fill the address.',
          placeholder: '01000-000',
          lookup: 'Look up address by CEP',
          invalidCep: 'CEP must have 8 digits',
          cepNotFound: 'CEP not found',
          cepFound: 'Address filled successfully',
          cepLookupError: 'Failed to look up CEP',
        },
        certificateFile: {
          label: 'A1 certificate (.pfx/.p12)',
          description: 'Optional. Without a certificate the company remains pending.',
          helper: 'The file will be sent as base64 to create/update the company in Focus NFe.',
        },
        certificatePassword: {
          label: 'Certificate password',
          placeholder: 'Enter the certificate password',
        },
      },
      actions: {
        uploadCertificate: 'Upload certificate',
        uploadingCertificate: 'Uploading...',
        saveCompany: 'Save',
        savingCompany: 'Saving...',
      },
      errors: {
        readFile: 'Failed to read file',
        invalidFileResult: 'Invalid file read result',
        loadConfiguration: 'Failed to load Focus NFe configuration',
      },
      validation: {
        certificateFileRequired: 'Select the certificate file (.pfx/.p12)',
        certificatePasswordRequired: 'Enter the certificate password',
        processAsApFromRequired:
          'Enter the date from which NF-es and NFS-es should be processed automatically.',
        nfeRecebimentoStartDateRequired: 'Enter the NF-e receivables start date before continuing.',
        nfeRecebimentoStartDateTooOld:
          'SEFAZ only distributes received NF-e from the last 90 days. Older invoices must be imported manually from their XML.',
        nextRpsInvalid: 'The next RPS must be an integer greater than zero.',
        rpsChangeReasonRequired: 'Enter the reason for changing the RPS sequence.',
      },
      toasts: {
        fiscalConfigError: 'Failed to load entity fiscal regime',
        modulesUpdated: 'Modules updated',
        modulesUpdateError: 'Failed to update modules',
        testSyncQueued: 'Test sync queued',
        testSyncError: 'Failed to queue test sync',
        allSyncQueued_one: '{{count}} sync queued.',
        allSyncQueued_other: '{{count}} syncs queued.',
        allSyncError_one: 'Failed to queue {{count}} sync.',
        allSyncError_other: 'Failed to queue {{count}} syncs.',
        allSyncGenericError: 'Failed to queue sync for all entities.',
        autoProcessEnabled: 'Automatic processing enabled.',
        autoProcessDisabled: 'Automatic processing disabled.',
        autoProcessUpdateError: 'Failed to update automatic processing.',
        autoProcessStartDateUpdated: 'Automatic processing start date updated.',
        autoProcessStartDateUpdateError: 'Failed to update automatic processing start date.',
        emissionModeUpdated: 'NFSe emission mode updated.',
        emissionModeUpdateError: 'Failed to update NFSe emission mode.',
        companySaved: 'Company configured. Certificate pending.',
        companyUpdated: 'Company updated in Focus NFe. Certificate kept.',
        certificateUploaded: 'Certificate uploaded and company configured in Focus NFe',
        companySaveError: 'Failed to configure entity in Focus NFe',
        emissionSettingsLoadError: 'Failed to load the Focus NFe RPS sequence.',
        rpsSequenceAdvanced: 'RPS sequence advanced in Focus NFe.',
        rpsSequenceAdvanceError: 'Failed to advance the RPS sequence in Focus NFe.',
      },
    },
  },
  dimensionReconciliation: {
    title: 'Integration mapping',
    subtitle: 'Map internal dimensions to external integrations.',
    tabs: {
      costCenters: 'Cost centers',
      departments: 'Departments',
      managerialAccounts: 'Managerial accounts',
    },
    dimensions: {
      costCenter: 'Cost center',
      department: 'Department',
      managerialAccount: 'Managerial account',
    },
    stats: {
      mapped: 'mapped',
      suggested: 'suggested',
      conflicts: 'conflicts',
      unmapped: 'unmapped',
    },
    actions: {
      generateSuggestions: 'Generate suggestions',
      acceptAll: 'Accept all ({{count}})',
    },
    banner: {
      message: '{{count}} mapping suggestions found. Review or accept all at once.',
      reconciling: 'Generating AI suggestions. This may take a few seconds...',
    },
    filters: {
      all: 'All',
      searchPlaceholder: 'Search by name, code, or entity...',
      statusLabel: 'Status',
      statusAll: 'All',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      pendingOnly: 'Only pending',
      entityLabel: 'Entity',
      entityPlaceholder: 'Select entity',
    },
    columns: {
      internal: 'Alchemy',
      notSupported: 'Not supported',
    },
    sync: {
      aria: 'Sync external items',
      tooltip: 'Fetch items from integration',
    },
    cell: {
      inactive: 'Inactive',
      mapped: 'Mapped',
      suggested: 'Suggested',
      conflict: 'Conflict',
      conflictCount: '{{count}} candidates',
      accept: 'Accept',
      reject: 'Reject',
      map: 'Map',
      edit: 'Change',
      remove: 'Unmap',
      primary: 'Primary',
      setPrimary: 'Set primary',
      setPrimaryTooltip:
        'The value selected as primary will be used for correlating this dimension when sending data back to the source',
    },
    delete: {
      confirm: 'Choose how you want to remove this mapping:',
      selected: 'Remove this mapping',
      all: 'Remove all',
    },
    unmatched: {
      title: 'External items without matches',
      subtitle: 'Items found in integrations without an internal counterpart.',
      suggested: 'Suggested',
      empty: 'No pending items',
      create: 'Create {{dimensionLabel}}',
    },
    empty: {
      externalItems: 'No items available',
    },
    errors: {
      loadMatrix: 'Failed to load reconciliation matrix.',
    },
    toasts: {
      suggestionsReady: 'Suggestions generated',
      suggestionsError: 'Failed to generate suggestions',
      noSuggestions: 'No suggestions available',
      acceptedAll: 'Suggestions applied',
      acceptAllError: 'Failed to apply suggestions',
      mappingCreated: 'Mapping created',
      mappingRemoved: 'Mapping removed',
      mappingError: 'Failed to update mapping',
      primaryUpdated: 'Primary mapping updated',
      selectEntity: 'Select an entity to create',
      createdFromExternal: 'Dimension created from external item',
      createError: 'Failed to create dimension',
      syncSuccess: 'External items synced',
      syncError: 'Failed to sync external items',
    },
    loading: 'Updating...',
    view: {
      matrix: 'Matrix',
    },
  },
  clara: {
    credentials: {
      title: 'Clara Credentials',
      description: 'Configure OAuth credentials and mTLS certificates to connect to the Clara API.',
      clientId: 'Client ID',
      clientIdPlaceholder: 'Enter OAuth Client ID',
      clientSecret: 'Client Secret',
      clientSecretPlaceholder: 'Enter OAuth Client Secret',
      showSecret: 'Show secret',
      hideSecret: 'Hide secret',
      importJson: 'Import JSON',
      importJsonDescription: 'Import the .json file provided by Clara to auto-fill all fields.',
      importJsonButton: 'Import .json file',
      importJsonSuccess: 'Credentials imported from JSON successfully.',
      importJsonError: 'Invalid JSON file. Check the format and try again.',
      orManual: 'or fill in manually',
      certificates: 'mTLS Certificates',
      certificatesHint: 'Already populated from JSON. Use the fields below only to override.',
      clientCert: 'Client Certificate (.crt)',
      clientKey: 'Private Key (.key)',
      save: 'Save Credentials',
      testConnection: 'Test Connection',
      connectedTitle: 'Clara Connection',
      connectedDescription: 'OAuth credentials and mTLS certificates are configured.',
      resetConnection: 'Reset Connection',
      resetConfirmTitle: 'Reset Clara connection?',
      resetConfirmDescription:
        'This will remove the stored OAuth credentials and mTLS certificates. You will need to configure the connection again to sync cards and transactions.',
      resetConfirmAction: 'Yes, reset',
      resetConfirmCancel: 'Cancel',
    },
    sync: {
      title: 'Synchronization',
      description: 'Sync cards and transactions manually or wait for automatic synchronization.',
      autoSyncLabel: 'Automatic Sync',
      autoSyncHelper: 'When disabled, cards and transactions will only sync manually.',
      autoCreateBillsLabel: 'Create payables from attachments',
      autoCreateBillsHelper:
        'Download receipts attached to Clara transactions and create payables automatically.',
      extractedDocumentEnrichmentLabel: 'Use Clara extracted data',
      extractedDocumentEnrichmentHelper:
        'Optional. Makes one additional Clara request per attachment-bearing transaction to enrich classification.',
      loadingConfig: 'Loading Clara sync settings',
      cards: 'Sync Cards',
      transactions: 'Sync Transactions',
      scheduleInfo: 'Cards are synced daily at 07:00. Transactions are synced daily at 08:00.',
    },
    entities: {
      title: 'Clara connections per company',
      description:
        'Each company uses the Clara of its country. The same credentials can be used on several companies.',
      loading: 'Loading companies',
      loadError: 'Failed to load Clara connections.',
      empty: 'No companies found.',
      market: 'Clara {{country}} · {{currency}}',
      taxId: '{{type}} {{value}}',
      taxIdMissing: 'Add the {{type}} of this company to connect Clara.',
      countryUnavailable: 'Clara is not available in this country.',
      notConnected: 'Not connected',
      lastSync: 'Last sync: {{date}}',
      neverSynced: 'Not synced yet',
      lastError: 'Last error: {{message}}',
      connect: 'Connect',
      replaceCredentials: 'Replace credentials',
      connectTitle: 'Connect Clara — {{entity}}',
      replaceTitle: 'Replace Clara credentials — {{entity}}',
      dialogDescription:
        'This company uses Clara {{country}}. Enter the OAuth credentials and mTLS certificates.',
      status: {
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        ERROR: 'Error',
      },
    },
    errors: {
      entityNotFound: 'Company not found.',
      countryUnsupported: 'Clara is not available in the country of this company.',
      taxIdMissing: 'The company has no tax ID of its country (CNPJ, RFC or NIT).',
      connectionNotFound: 'Clara is not connected for this company.',
      connectionInactive:
        'The Clara connection of this company is inactive. Enter the credentials again.',
      credentialsMissing: 'Enter the Clara credentials to connect this company.',
      credentialsRejected:
        'Clara rejected the credentials or the certificate. Replace the credentials of this company.',
      apiUnavailable: 'Clara is not available now. The sync tries again on its own.',
      syncFailed: 'The Clara sync failed.',
    },
    toasts: {
      credentialsSaved: 'Clara credentials saved successfully.',
      credentialsError: 'Failed to save Clara credentials.',
      connectionSuccess: 'Clara connection established successfully!',
      connectionFailed: 'Clara connection failed. Check your credentials.',
      cardSyncEnqueued: 'Card sync started.',
      cardSyncAlreadyRunning: 'Card sync already in progress.',
      transactionSyncEnqueued: 'Transaction sync started.',
      transactionSyncAlreadyRunning: 'Transaction sync already in progress.',
      syncError: 'Failed to start sync.',
      resetSuccess: 'Clara connection reset successfully.',
      resetError: 'Failed to reset Clara connection.',
      settingsError: 'Failed to save Clara settings.',
    },
  },
  fiscalApiPdfBranding: {
    title: 'PDF branding',
    description:
      'Logo and colors of the PDF of the CFDIs this entity issues. They apply to PDFs generated from now on; the XML (the fiscal document) does not change. To apply them to an already-issued CFDI, use "Regenerate PDF" in Issued invoices.',
    logo: 'Logo',
    logoHint: 'PNG or JPEG, up to 500 KB.',
    logoPreviewAlt: 'PDF logo',
    noLogo: 'No logo',
    chooseLogo: 'Upload logo',
    replaceLogo: 'Replace logo',
    removeLogo: 'Remove logo',
    bandColor: 'Band color',
    fontColor: 'Font color',
    colorPicker: 'Color picker',
    colorPlaceholder: '#RRGGBB',
    colorInvalid: 'Use the #RRGGBB format.',
    colorDefault: 'Empty uses the provider default.',
    save: 'Save colors',
    toasts: {
      saved: 'PDF branding saved',
      logoSaved: 'Logo uploaded',
      logoRemoved: 'Logo removed',
      logoType: 'The logo must be a PNG or JPEG.',
      logoSize: 'The logo must be at most 500 KB.',
    },
  },
} as const;
